(function(){try{

      (function() {
        // Cookies to block before consent
        const blockedPatterns = ['_gegeo', '_geran', '_geref', '_gers', '_getdran', '_geuid', '_getd', '_lc2_fpi', '_lc2_fpi_js', 'eabUserId',
         '_li_dcdm_c', '_reidsn', 'lidid', 'uuid', 'ABAU', 'ABTL', 'cf_76396_first_touch', 'cf_76396_id', 'cf_76396_person_last_update'];
        
        // Third-party script domains to block (these set cookies on their domains)
        const blockedScriptDomains = ['liadm.com', 'alocdn.com', 'liveintent.com', 'lijit.com'];
        
        // Track consent state
        window.__ccpaConsentGranted = false;
        window.__ccpaIsRegulatedRegion = true; // Assume regulated until Consentmo tells us otherwise
        
        // Queue to store blocked cookies for later replay
        window.__ccpaBlockedCookieQueue = [];
        
        // Queue to store blocked scripts for later loading
        window.__ccpaBlockedScriptQueue = [];
        
        // Reference to monitoring intervals/callbacks
        let fastIntervalId = null;
        let slowIntervalId = null;
        let monitoringActive = true;
        let monitorCount = 0;
        const MAX_MONITORS = 200;
        
        // Check if URL matches blocked domains
        function isBlockedScriptDomain(url) {
          if (!url) return false;
          try {
            const urlObj = new URL(url, window.location.origin);
            return blockedScriptDomains.some(function(domain) {
              return urlObj.hostname.indexOf(domain) !== -1;
            });
          } catch (e) {
            return blockedScriptDomains.some(function(domain) {
              return url.indexOf(domain) !== -1;
            });
          }
        }
        
        // Block third-party scripts by intercepting script creation
        const originalCreateElement = document.createElement.bind(document);
        document.createElement = function(tagName) {
          const element = originalCreateElement(tagName);
          
          if (tagName.toLowerCase() === 'script') {
            const originalSetAttribute = element.setAttribute.bind(element);
            element.setAttribute = function(name, value) {
              if (name === 'src' && window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                if (isBlockedScriptDomain(value)) {
                  // Store script info for later loading
                  window.__ccpaBlockedScriptQueue.push({
                    src: value,
                    async: element.async,
                    defer: element.defer,
                    type: element.type,
                    id: element.id
                  });
                  // Set a data attribute instead to prevent loading
                  return originalSetAttribute('data-blocked-src', value);
                }
              }
              return originalSetAttribute(name, value);
            };
            
            // Also intercept direct src assignment
            Object.defineProperty(element, 'src', {
              get: function() {
                return element.getAttribute('src') || element.getAttribute('data-blocked-src') || '';
              },
              set: function(value) {
                if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted && isBlockedScriptDomain(value)) {
                  window.__ccpaBlockedScriptQueue.push({
                    src: value,
                    async: element.async,
                    defer: element.defer,
                    type: element.type,
                    id: element.id
                  });
                  element.setAttribute('data-blocked-src', value);
                  return value;
                }
                element.setAttribute('src', value);
                return value;
              },
              configurable: true
            });
          }
          
          return element;
        };
        
        // Block iframes and scripts via MutationObserver
        const observer = new MutationObserver(function(mutations) {
          if (!window.__ccpaIsRegulatedRegion || window.__ccpaConsentGranted) return;
          
          mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType !== 1) return; // Only element nodes
              
              // Block iframes
              if (node.tagName === 'IFRAME' && isBlockedScriptDomain(node.src)) {
                node.setAttribute('data-blocked-src', node.src);
                node.removeAttribute('src');
              }
              
              // Block script tags added to DOM
              if (node.tagName === 'SCRIPT' && node.src && isBlockedScriptDomain(node.src)) {
                window.__ccpaBlockedScriptQueue.push({
                  src: node.src,
                  async: node.async,
                  defer: node.defer,
                  type: node.type,
                  id: node.id
                });
                node.setAttribute('data-blocked-src', node.src);
                node.removeAttribute('src');
              }
              
              // Block img pixels from blocked domains
              if (node.tagName === 'IMG' && isBlockedScriptDomain(node.src)) {
                node.setAttribute('data-blocked-src', node.src);
                node.removeAttribute('src');
              }
            });
          });
        });
        
        observer.observe(document.documentElement, { childList: true, subtree: true });
        
        // Intercept fetch requests to blocked domains
        const originalFetch = window.fetch;
        window.__ccpaBlockedFetchQueue = [];
        window.fetch = function(url, options) {
          if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
            const urlString = typeof url === 'string' ? url : (url.url || url.toString());
            if (isBlockedScriptDomain(urlString)) {
              // Queue the request for later
              window.__ccpaBlockedFetchQueue.push({ url: url, options: options });
              // Return a resolved promise with empty response
              return Promise.resolve(new Response('', { status: 200 }));
            }
          }
          return originalFetch.apply(this, arguments);
        };
        
        // Intercept XMLHttpRequest to blocked domains
        const originalXHROpen = XMLHttpRequest.prototype.open;
        const originalXHRSend = XMLHttpRequest.prototype.send;
        window.__ccpaBlockedXHRQueue = [];
        
        XMLHttpRequest.prototype.open = function(method, url) {
          this.__ccpaBlockedUrl = url;
          this.__ccpaBlockedMethod = method;
          return originalXHROpen.apply(this, arguments);
        };
        
        XMLHttpRequest.prototype.send = function(body) {
          if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
            if (this.__ccpaBlockedUrl && isBlockedScriptDomain(this.__ccpaBlockedUrl)) {
              window.__ccpaBlockedXHRQueue.push({
                method: this.__ccpaBlockedMethod,
                url: this.__ccpaBlockedUrl,
                body: body
              });
              return; // Don't send the request
            }
          }
          return originalXHRSend.apply(this, arguments);
        };
        
        // Intercept Image src to block tracking pixels
        const originalImageDescriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
        if (originalImageDescriptor) {
          Object.defineProperty(HTMLImageElement.prototype, 'src', {
            get: function() {
              return originalImageDescriptor.get.call(this);
            },
            set: function(value) {
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted && isBlockedScriptDomain(value)) {
                this.setAttribute('data-blocked-src', value);
                return value;
              }
              return originalImageDescriptor.set.call(this, value);
            },
            configurable: true
          });
        }
        
        // Intercept navigator.sendBeacon (used by some trackers)
        const originalSendBeacon = navigator.sendBeacon;
        window.__ccpaBlockedBeaconQueue = [];
        if (originalSendBeacon) {
          navigator.sendBeacon = function(url, data) {
            if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted && isBlockedScriptDomain(url)) {
              window.__ccpaBlockedBeaconQueue.push({ url: url, data: data });
              return true; // Pretend it was sent
            }
            return originalSendBeacon.apply(navigator, arguments);
          };
        }
        
        // Block existing elements on page load (for elements already in DOM)
        function blockExistingElements() {
          if (!window.__ccpaIsRegulatedRegion || window.__ccpaConsentGranted) return;
          
          // Block existing scripts from blocked domains
          document.querySelectorAll('script[src]').forEach(function(script) {
            if (isBlockedScriptDomain(script.src) && !script.hasAttribute('data-blocked-src')) {
              window.__ccpaBlockedScriptQueue.push({
                src: script.src,
                async: script.async,
                defer: script.defer,
                type: script.type,
                id: script.id
              });
              script.setAttribute('data-blocked-src', script.src);
              script.removeAttribute('src');
            }
          });
          
          // Block existing iframes
          document.querySelectorAll('iframe[src]').forEach(function(iframe) {
            if (isBlockedScriptDomain(iframe.src) && !iframe.hasAttribute('data-blocked-src')) {
              iframe.setAttribute('data-blocked-src', iframe.src);
              iframe.removeAttribute('src');
            }
          });
          
          // Block existing images
          document.querySelectorAll('img[src]').forEach(function(img) {
            if (isBlockedScriptDomain(img.src) && !img.hasAttribute('data-blocked-src')) {
              img.setAttribute('data-blocked-src', img.src);
              img.removeAttribute('src');
            }
          });
        }
        
        // Run blocking on existing elements immediately and after DOM ready
        blockExistingElements();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', blockExistingElements);
        }
        
        // Delete blocked cookies
        function deleteBlockedCookies() {
          const cookies = document.cookie.split(';');
          const domain = location.hostname;
          
          cookies.forEach(function(c) {
            const name = c.split('=')[0].trim();
            if (blockedPatterns.some(function(p) { return name.indexOf(p) !== -1; })) {
              // Try all combinations of path and domain
              const paths = ['/', '', '/pages', '/collections', '/products'];
              const domains = ['', domain, '.' + domain];
              
              paths.forEach(function(path) {
                domains.forEach(function(d) {
                  const domainPart = d ? '; domain=' + d : '';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/') + domainPart;
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/') + domainPart + '; SameSite=Lax';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/') + domainPart + '; SameSite=None; Secure';
                });
              });
            }
          });
        }
        
        // Load blocked scripts after consent
        function loadBlockedScripts() {
          if (window.__ccpaBlockedScriptQueue.length > 0) {
            window.__ccpaBlockedScriptQueue.forEach(function(scriptInfo) {
              const script = originalCreateElement('script');
              if (scriptInfo.async) script.async = true;
              if (scriptInfo.defer) script.defer = true;
              if (scriptInfo.type) script.type = scriptInfo.type;
              if (scriptInfo.id) script.id = scriptInfo.id + '-loaded';
              script.src = scriptInfo.src;
              document.head.appendChild(script);
            });
            window.__ccpaBlockedScriptQueue = [];
          }
          
          // Unblock iframes
          document.querySelectorAll('iframe[data-blocked-src]').forEach(function(iframe) {
            iframe.src = iframe.getAttribute('data-blocked-src');
            iframe.removeAttribute('data-blocked-src');
          });
          
          // Unblock images (tracking pixels)
          document.querySelectorAll('img[data-blocked-src]').forEach(function(img) {
            if (originalImageDescriptor) {
              originalImageDescriptor.set.call(img, img.getAttribute('data-blocked-src'));
            } else {
              img.src = img.getAttribute('data-blocked-src');
            }
            img.removeAttribute('data-blocked-src');
          });
          
          // Replay blocked fetch requests
          if (window.__ccpaBlockedFetchQueue && window.__ccpaBlockedFetchQueue.length > 0) {
            window.__ccpaBlockedFetchQueue.forEach(function(req) {
              originalFetch(req.url, req.options);
            });
            window.__ccpaBlockedFetchQueue = [];
          }
          
          // Replay blocked XHR requests
          if (window.__ccpaBlockedXHRQueue && window.__ccpaBlockedXHRQueue.length > 0) {
            window.__ccpaBlockedXHRQueue.forEach(function(req) {
              const xhr = new XMLHttpRequest();
              originalXHROpen.call(xhr, req.method, req.url);
              originalXHRSend.call(xhr, req.body);
            });
            window.__ccpaBlockedXHRQueue = [];
          }
          
          // Replay blocked sendBeacon requests
          if (window.__ccpaBlockedBeaconQueue && window.__ccpaBlockedBeaconQueue.length > 0 && originalSendBeacon) {
            window.__ccpaBlockedBeaconQueue.forEach(function(req) {
              originalSendBeacon.call(navigator, req.url, req.data);
            });
            window.__ccpaBlockedBeaconQueue = [];
          }
        }
        
        // Replay all queued cookies after consent
        function replayBlockedCookies() {
          const cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') || 
                            Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
          
          if (cookieDesc && cookieDesc.set && window.__ccpaBlockedCookieQueue.length > 0) {
            
            window.__ccpaBlockedCookieQueue.forEach(function(cookieValue) {
              try {
                cookieDesc.set.call(document, cookieValue);
              } catch (e) {
                console.error('[CCPA] Failed to set cookie:', e);
              }
            });
            
            // Clear the queue after replay
            window.__ccpaBlockedCookieQueue = [];
          }
          
          // Load blocked third-party scripts
          loadBlockedScripts();
        }
        
        // Stop all monitoring
        function stopMonitoring() {
          monitoringActive = false;
          if (fastIntervalId) {
            if ('cancelIdleCallback' in window) {
              cancelIdleCallback(fastIntervalId);
            } else {
              clearTimeout(fastIntervalId);
            }
            fastIntervalId = null;
          }
          if (slowIntervalId) {
            if ('cancelIdleCallback' in window) {
              cancelIdleCallback(slowIntervalId);
            } else {
              clearTimeout(slowIntervalId);
            }
            slowIntervalId = null;
          }
        }

        // Override document.cookie setter to intercept cookies
        const cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') || 
                          Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
        
        if (cookieDesc && cookieDesc.set) {
          Object.defineProperty(document, 'cookie', {
            get: function() {
              return cookieDesc.get.call(document);
            },
            set: function(value) {
              // Only block if in regulated region AND consent not granted
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                const cookieName = value.split('=')[0].trim();
                if (blockedPatterns.some(function(p) { return cookieName.indexOf(p) !== -1; })) {
                  
                  // Store the full cookie value for later replay
                  // Check if not already in queue (avoid duplicates)
                  const existingIndex = window.__ccpaBlockedCookieQueue.findIndex(function(c) {
                    return c.split('=')[0].trim() === cookieName;
                  });
                  
                  if (existingIndex >= 0) {
                    // Update existing cookie in queue with new value
                    window.__ccpaBlockedCookieQueue[existingIndex] = value;
                  } else {
                    // Add new cookie to queue
                    window.__ccpaBlockedCookieQueue.push(value);
                  }
                  
                  return value; // Don't actually set it yet
                }
              }
              return cookieDesc.set.call(document, value);
            },
            configurable: true
          });
        }

        // Idle-based monitoring — only deletes cookies when browser is idle,
        // never during user interactions (prevents INP impact).
        // Uses requestIdleCallback with 2s timeout as compliance safety net.
        // Falls back to setTimeout(2000) for browsers without rIC support.
        function scheduleIdleCookieCheck() {
          if (!monitoringActive) return;
          if (monitorCount >= MAX_MONITORS) {
            scheduleSlowMonitoring();
            return;
          }

          if ('requestIdleCallback' in window) {
            fastIntervalId = requestIdleCallback(function() {
              if (!monitoringActive) return;
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                deleteBlockedCookies();
              }
              monitorCount++;
              scheduleIdleCookieCheck();
            }, { timeout: 2000 });
          } else {
            fastIntervalId = setTimeout(function() {
              if (!monitoringActive) return;
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                deleteBlockedCookies();
              }
              monitorCount++;
              scheduleIdleCookieCheck();
            }, 2000);
          }
        }

        function scheduleSlowMonitoring() {
          document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'visible' && monitoringActive &&
                window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
              deleteBlockedCookies();
            }
          });

          function slowCheck() {
            if (!monitoringActive) return;
            if ('requestIdleCallback' in window) {
              slowIntervalId = requestIdleCallback(function() {
                if (!monitoringActive) return;
                if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                  deleteBlockedCookies();
                }
                slowCheck();
              }, { timeout: 10000 });
            } else {
              slowIntervalId = setTimeout(function() {
                if (!monitoringActive) return;
                if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                  deleteBlockedCookies();
                }
                slowCheck();
              }, 5000);
            }
          }
          slowCheck();
        }

        scheduleIdleCookieCheck();

        // Initial cleanup
        deleteBlockedCookies();
        
        // Export functions for consent handlers
        window.__ccpaEnableCookies = function() {
          window.__ccpaConsentGranted = true;
          
          // Stop monitoring/deleting cookies
          stopMonitoring();
          
          // Replay all blocked cookies that were queued
          replayBlockedCookies();
        };
        
        window.__ccpaDisableCookies = function() {
          window.__ccpaConsentGranted = false;
          deleteBlockedCookies();
          // Restart monitoring if it was previously stopped (e.g. consent revoked after grant)
          if (!monitoringActive) {
            monitoringActive = true;
            monitorCount = 0;
            scheduleIdleCookieCheck();
          }
        };
        
        window.__ccpaSetRegulatedRegion = function(isRegulated) {
          window.__ccpaIsRegulatedRegion = isRegulated;
          if (!isRegulated) {
            window.__ccpaConsentGranted = true;
            
            // Stop monitoring for non-regulated regions
            stopMonitoring();
            
            // Replay any cookies that might have been blocked before region was determined
            replayBlockedCookies();
          }
        };
      })();
    
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
window.__igHeroRegion = "us";
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  (function () {
    var done = false;
    function reveal() {
      if (done) return; done = true;
      var w = document.querySelector('.s-main-product__gallery-wrapper');
      if (w) w.classList.add('ig-mwg-ready');
      var s = document.getElementById('ig-mwg-prehide');
      if (s && s.parentNode) s.parentNode.removeChild(s);
    }
    // The Variant reveals itself: variant.js adds `.ig-mwg-ready` the instant its
    // swap is painted, so the original never shows — no matter how slow the IG
    // bundle is. We must NOT reveal early for the Variant, or we'd flash the
    // original. So when Intelligems finishes applying the group (`ig:ready`),
    // reveal ONLY if the variant script is NOT running (Control / unassigned).
    window.addEventListener('ig:ready', function () {
      if (!window.__igMwgActive) reveal();
    });
    // Hard safety — only bites on true failure (IG never loads, or the swap
    // never paints). The happy path reveals well before this, so it doesn't sit
    // on the critical path for normal visitors.
    setTimeout(reveal, 2500);
  })();
  
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function() {
  var COOKIE_NAME = 'lang_preference_set';
  var SUPPORTED = ["en","es","de","fr"];
  var DEFAULT_LOCALE = "en";
  var CURRENT_LOCALE = "en";

  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m[2] : null;
  }
  function setPrefCookie(value) {
    var d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_NAME + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function attachManualHandlers() {
    var nodes = document.querySelectorAll('button[name="locale_code"]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].addEventListener('click', function(e) {
        var v = e.currentTarget.value;
        if (SUPPORTED.indexOf(v) !== -1) setPrefCookie(v);
      }, { passive: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachManualHandlers, { passive: true });
  } else {
    attachManualHandlers();
  }

  var savedRaw = getCookie(COOKIE_NAME);
  var savedLocale = (savedRaw && SUPPORTED.indexOf(savedRaw) !== -1) ? savedRaw : null;

  // 1. Persistence: served default-locale URL but cookie says non-default → redirect
  if (savedLocale && savedLocale !== DEFAULT_LOCALE && CURRENT_LOCALE === DEFAULT_LOCALE) {
    var path = window.location.pathname.replace(/\/collections\/all\/?$/, '/collections/all-products');
    window.location.replace('/' + savedLocale + path + window.location.search + window.location.hash);
    return;
  }

  // 2. Sync cookie with current page's locale (handles legacy '1' cookie + cross-locale clicks)
  if (CURRENT_LOCALE && SUPPORTED.indexOf(CURRENT_LOCALE) !== -1 && CURRENT_LOCALE !== savedLocale) {
    setPrefCookie(CURRENT_LOCALE);
  }

  // 3. First visit (no cookie at all): auto-detect from browser language on homepage
  if (savedRaw) return;
  if (window.location.pathname !== '/') return;

  var browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase().split('-')[0];
  if (!browserLang || browserLang === CURRENT_LOCALE) return;
  if (SUPPORTED.indexOf(browserLang) === -1 || browserLang === DEFAULT_LOCALE) return;

  setPrefCookie(browserLang);
  window.location.replace('/' + browserLang + '/' + window.location.search + window.location.hash);
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function() {
  if (!('PerformanceObserver' in window)) {
    window.getCLSDetails = () => ({ totalCLS: 0, entries: [], topShifts: [] });
    return;
  }
  
  let clsValue = 0;
  let clsEntries = [];
  
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (!entry.hadRecentInput) {
        clsValue += entry.value;
        clsEntries.push({
          value: entry.value,
          sources: entry.sources || [],
          startTime: entry.startTime
        });
      }
    }
  });
  
  window.getCLSDetails = () => ({
    totalCLS: clsValue,
    entries: clsEntries,
    topShifts: [...clsEntries].sort((a, b) => b.value - a.value).slice(0, 10)
  });
  
  try {
    observer.observe({ type: 'layout-shift', buffered: true });
  } catch (e) {}
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  // This allows to expose several variables to the global scope, to be used in scripts
  window.themeVariables = {
    settings: {
      direction: "ltr",
      pageType: "product",
      cartCount: 0,
      moneyFormat: "${{amount}}",
      moneyWithCurrencyFormat: "${{amount}} USD",
      showVendor: false,
      discountMode: "saving",
      currencyCodeEnabled: false,
      searchMode: "product\n  ,article\n  \n  ,collection\n",
      searchUnavailableProducts: "last",
      cartType: "drawer",
      cartCurrency: "USD",
      currencyCode: "USD",
      currencySymbol: "$",
      conversionRate: 1.0,
      mobileZoomFactor: 2.5
    },

    routes: {
      host: "refirmorganics.com",
      rootUrl: "\/",
      rootUrlWithoutSlash: '',
      cartUrl: "\/cart",
      cartAddUrl: "\/cart\/add",
      cartChangeUrl: "\/cart\/change",
      cartUpdateUrl: "\/cart\/update",
      searchUrl: "\/search",
      predictiveSearchUrl: "\/search\/suggest",
      productRecommendationsUrl: "\/recommendations\/products"
    },

    strings: {
      accessibilityDelete: "Delete",
      accessibilityClose: "Close",
      collectionSoldOut: "Sold out",
      collectionDiscount: "You save @savings@",
      productSalePrice: "Sale price",
      productRegularPrice: "Regular price",
      productFormUnavailable: "Unavailable",
      productFormSoldOut: "Sold out",
      productFormPreOrder: "Pre-order",
      productFormAddToCart: "Add to cart",
      searchNoResults: "No results could be found.",
      searchNewSearch: "New search",
      searchProducts: "Products",
      searchArticles: "Journal",
      searchPages: "Pages",
      searchCollections: "Collections",
      cartViewCart: "View cart",
      cartItemAdded: "Item added to your cart!",
      cartItemAddedShort: "Added to your cart!",
      cartAddOrderNote: "Add order note",
      cartEditOrderNote: "Edit order note",
      shippingEstimatorNoResults: "Sorry, we do not ship to your address.",
      shippingEstimatorOneResult: "There is one shipping rate for your address:",
      shippingEstimatorMultipleResults: "There are several shipping rates for your address:",
      shippingEstimatorError: "One or more error occurred while retrieving shipping rates:"
    },

    libs: {
      flickity: "\/\/froyaorganics.com\/cdn\/shop\/t\/207\/assets\/flickity.js?v=176646718982628074891775650485",
      photoswipe: "\/\/froyaorganics.com\/cdn\/shop\/t\/207\/assets\/photoswipe.js?v=132268647426145925301775650485",
      qrCode: "\/\/froyaorganics.com\/cdn\/shopifycloud\/storefront\/assets\/themes_support\/vendor\/qrcode-1f6c2eb7.js"
    },

    breakpoints: {
      phone: 'screen and (max-width: 740px)',
      tablet: 'screen and (min-width: 741px) and (max-width: 999px)',
      tabletAndUp: 'screen and (min-width: 741px)',
      pocket: 'screen and (max-width: 999px)',
      lap: 'screen and (min-width: 1000px) and (max-width: 1199px)',
      lapAndUp: 'screen and (min-width: 1000px)',
      desktop: 'screen and (min-width: 1200px)',
      wide: 'screen and (min-width: 1400px)'
    }
  };

  // Initialize cart on page load
  window.addEventListener('pageshow', async () => {
    const cartContent = await (await fetch(`${window.themeVariables.routes.cartUrl}.js`, {cache: 'reload'})).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {detail: {cart: cartContent}}));
  });


  // Modern browser detection
  if ('noModule' in HTMLScriptElement.prototype) {
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

    requestAnimationFrame(() => {
      const viewportHeight = (window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight);
      document.documentElement.style.setProperty('--window-height', viewportHeight + 'px');
    });
  }// Recently viewed products
    try {
      const items = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
      if (!items.includes(8329639985301)) {
        items.unshift(8329639985301);
      }
      localStorage.setItem('theme:recently-viewed-products', JSON.stringify(items.slice(0, 20)));
    } catch (e) {
      // Safari in private mode handling
    }
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

!function() {
  const html = document.documentElement;
  const removeLoading = function() {
    html.classList.remove('loading');
    html.classList.add('loaded');
  };
  
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    removeLoading();
  } else {
    requestAnimationFrame(function() {
      document.addEventListener('DOMContentLoaded', removeLoading, { passive: true, once: true });
      window.addEventListener('load', removeLoading, { passive: true, once: true });
      setTimeout(removeLoading, 1000);
    });
  }
}();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function() {
  function loadDeferredCSS() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        const customCSS = document.createElement('link');
        customCSS.rel = 'stylesheet';
        customCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/custom.css?v=26511617089700387831779403283';
        document.head.appendChild(customCSS);
        
        const blazeCSS = document.createElement('link');
        blazeCSS.rel = 'stylesheet';
        blazeCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/blaze.css?v=1372562978454044851778536877';
        document.head.appendChild(blazeCSS);
      }, { timeout: 2000 });
    } else {
      setTimeout(function() {
        const customCSS = document.createElement('link');
        customCSS.rel = 'stylesheet';
        customCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/custom.css?v=26511617089700387831779403283';
        document.head.appendChild(customCSS);

        const blazeCSS = document.createElement('link');
        blazeCSS.rel = 'stylesheet';
        blazeCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/blaze.css?v=1372562978454044851778536877';
        document.head.appendChild(blazeCSS);
      }, 2000);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadDeferredCSS, { passive: true });
  } else {
    loadDeferredCSS();
  }
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

!function(e){"use strict";var t=function(t,n,o){var i,r=e.document,a=r.createElement("link");if(o)i=o;else{var l=(r.body||r.getElementsByTagName("head")[0]).childNodes;i=l[l.length-1]}var d=r.styleSheets;a.rel="stylesheet",a.href=t,a.media="only x",function e(t){if(r.body)return t();setTimeout(function(){e(t)})}(function(){i.parentNode.insertBefore(a,o?i:i.nextSibling)});var f=function(e){for(var t=a.href,n=r.styleSheets.length-1;n>=0&&r.styleSheets[n].href!==t;n--);return n>=0&&(a.onload=null,a.media="all"),e};return a.addEventListener&&a.addEventListener("load",f),a.onloadcssdefined=f,f(a),a};"undefined"!=typeof exports?exports.loadCSS=t:e.loadCSS=t}("undefined"!=typeof global?global:this);

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

// Defer polyfills loading until after critical resources
(function() {
  function loadPolyfills() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        const script = document.createElement('script');
        script.src = '//froyaorganics.com/cdn/shop/t/207/assets/polyfills.js?v=108754101037183893151783040932';
        script.defer = true;
        document.head.appendChild(script);
      }, { timeout: 2000 });
    } else {
      // Wait for page load to complete before loading polyfills
      window.addEventListener('load', function() {
        const script = document.createElement('script');
        script.src = '//froyaorganics.com/cdn/shop/t/207/assets/polyfills.js?v=108754101037183893151783040932';
        script.defer = true;
        document.head.appendChild(script);
      }, { passive: true, once: true });
    }
  }
  
  // Only load after DOM is ready and page is interactive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPolyfills, { passive: true, once: true });
  } else {
    loadPolyfills();
  }
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

// Defer custom.js loading until after page is interactive
(function() {
  let customJsLoaded = false;
  function loadCustomJs() {
    if (customJsLoaded) return;
    customJsLoaded = true;
    const script = document.createElement('script');
    script.src = '//froyaorganics.com/cdn/shop/t/207/assets/custom.js?v=8496188798234972491783040929';
    script.defer = true;
    document.head.appendChild(script);
  }
  
  // Wait for page to be fully loaded and interactive before loading custom.js
  if (document.readyState === 'complete') {
    // Use requestIdleCallback if available
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadCustomJs, { timeout: 3000 });
    } else {
      setTimeout(loadCustomJs, 3000);
    }
  } else {
    window.addEventListener('load', function() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadCustomJs, { timeout: 3000 });
      } else {
        setTimeout(loadCustomJs, 3000);
      }
    }, { passive: true, once: true });
  }
  
  // Only load on user interaction as fallback - use single delegated listener for better INP
  if (!window._customJsListenerAdded) {
    window._customJsListenerAdded = true;
    document.addEventListener('click', loadCustomJs, { passive: true, once: true });
    document.addEventListener('touchstart', loadCustomJs, { passive: true, once: true });
  }
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

window.shopCurrency = "USD";

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  window._template = {
    directory: null,
    name: "product",
    suffix: "systems"
  };
  window.__productIdFromTemplate = 8329639985301;
  window.__plpCollectionIdFromTemplate = null;
  window.igProductData = (function() {
    var data = {};data[52940429459823] = {
          price: 15900,
          compare_at_price: 20000,
          product_id: 8329639985301
        };return data;
  })();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function() {
  var revealed = false;
  function reveal() {
    if (revealed) return;
    revealed = true;
    var s = document.getElementById('ig-anti-flicker-nav-logo');
    if (s) s.remove();
  }
  document.addEventListener('ig:ready', reveal);
  window.addEventListener('ig:ready', reveal);
  setTimeout(reveal, 400);
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
window.performance && window.performance.mark && window.performance.mark('shopify.content_for_header.start');
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
var Shopify = Shopify || {};
Shopify.shop = "volantaromaeu.myshopify.com";
Shopify.locale = "en";
Shopify.currency = {"active":"USD","rate":"1.0"};
Shopify.country = "US";
Shopify.theme = {"name":"REFIRM - LIVE (GitHub)","id":185750618479,"schema_name":"Focal","schema_version":"9.1.0","theme_store_id":null,"role":"main"};
Shopify.theme.handle = "null";
Shopify.theme.style = {"id":null,"handle":null};
Shopify.cdnHost = "refirmorganics.com/cdn";
Shopify.routes = Shopify.routes || {};
Shopify.routes.root = "/";
Shopify.shopJsCdnBaseUrl = "https://cdn.shopify.com/shopifycloud/shop-js";
Shopify.SignInWithShop = Shopify.SignInWithShop || {};
Shopify.SignInWithShop.User = Shopify.SignInWithShop.User || {};
Shopify.SignInWithShop.User.recognized = false;
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
!function(o){function n(){var o=[];function n(){o.push(Array.prototype.slice.apply(arguments))}return n.q=o,n}var t=o.Shopify=o.Shopify||{};t.loadFeatures=n(),t.autoloadFeatures=n()}(window);
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  window.ShopifyPay = window.ShopifyPay || {};
  window.ShopifyPay.apiHost = "shop.app\/pay";
  window.ShopifyPay.redirectState = null;

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  window.Shopify = window.Shopify || {};
  window.Shopify.SignInWithShop = window.Shopify.SignInWithShop || {};
  window.Shopify.SignInWithShop.assetMetrics = { sampleRate: 0.01 };
  window.Shopify.SignInWithShop.eligible = true;

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  window.Shopify = window.Shopify || {};
  if (!window.Shopify.featureAssets) window.Shopify.featureAssets = {};
  window.Shopify.featureAssets['shop-js'] = {"shop-toast-manager":["modules/v2/loader.shop-toast-manager.en.esm.js"],"listener":["modules/v2/loader.listener.en.esm.js"],"init-shop-user-recognition":["modules/v2/loader.init-shop-user-recognition.en.esm.js"],"checkout-modal":["modules/v2/loader.checkout-modal.en.esm.js"],"init-fed-cm":["modules/v2/loader.init-fed-cm.en.esm.js"],"shop-cash-offers":["modules/v2/loader.shop-cash-offers.en.esm.js"],"avatar":["modules/v2/loader.avatar.en.esm.js"],"init-windoid":["modules/v2/loader.init-windoid.en.esm.js"],"init-shop-cart-sync":["modules/v2/loader.init-shop-cart-sync.en.esm.js"],"init-customer-accounts-sign-up":["modules/v2/loader.init-customer-accounts-sign-up.en.esm.js"],"shop-user-recognition":["modules/v2/loader.shop-user-recognition.en.esm.js"],"init-shop-email-lookup-coordinator":["modules/v2/loader.init-shop-email-lookup-coordinator.en.esm.js"],"shop-button":["modules/v2/loader.shop-button.en.esm.js"],"shop-login-button":["modules/v2/loader.shop-login-button.en.esm.js"],"pay-button":["modules/v2/loader.pay-button.en.esm.js"],"shop-login":["modules/v2/loader.shop-login.en.esm.js"],"init-shop-for-new-customer-accounts":["modules/v2/loader.init-shop-for-new-customer-accounts.en.esm.js"],"init-customer-accounts":["modules/v2/loader.init-customer-accounts.en.esm.js"],"shop-follow-button":["modules/v2/loader.shop-follow-button.en.esm.js"],"shop-cart-sync":["modules/v2/loader.shop-cart-sync.en.esm.js"],"lead-capture":["modules/v2/loader.lead-capture.en.esm.js"],"payment-terms":["modules/v2/loader.payment-terms.en.esm.js"]};

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
var __st={"a":47399993493,"offset":-14400,"reqid":"4f939a91-93cf-488b-b08f-e9070eb10cc7-1784083737","pageurl":"refirmorganics.com\/products\/the-complete-under-eye-system","u":"481bc030a148","p":"product","rtyp":"product","rid":8329639985301};
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
window.ShopifyPaypalV4VisibilityTracking = true;
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
!function(){'use strict';const t='contact',e='account',n='new_comment',o=[[t,t],['blogs',n],['comments',n],[t,'customer']],c=[[e,'customer_login'],[e,'guest_login'],[e,'recover_customer_password'],[e,'create_customer']],r=t=>t.map((([t,e])=>`form[action*='/${t}']:not([data-nocaptcha='true']) input[name='form_type'][value='${e}']`)).join(','),a=t=>()=>t?[...document.querySelectorAll(t)].map((t=>t.form)):[];function s(){const t=[...o],e=r(t);return a(e)}const i='password',u='form_key',d=['recaptcha-v3-token','g-recaptcha-response','h-captcha-response',i],f=()=>{try{return window.sessionStorage}catch{return}},m='__shopify_v',_=t=>t.elements[u];function p(t,e,n=!1){try{const o=window.sessionStorage,c=JSON.parse(o.getItem(e)),{data:r}=function(t){const{data:e,action:n}=t;return t[m]||n?{data:e,action:n}:{data:t,action:n}}(c);for(const[e,n]of Object.entries(r))t.elements[e]&&(t.elements[e].value=n);n&&o.removeItem(e)}catch(o){console.error('form repopulation failed',{error:o})}}const l='form_type',E='cptcha';function T(t){t.dataset[E]=!0}const w=window,h=w.document,L='Shopify',v='ce_forms',y='captcha';let A=!1;((t,e)=>{const n=(g='f06e6c50-85a8-45c8-87d0-21a2b65856fe',I='https://cdn.shopify.com/shopifycloud/storefront-forms-hcaptcha/ce_storefront_forms_captcha_hcaptcha.v1.5.2.iife.js',D={infoText:'Protected by hCaptcha',privacyText:'Privacy',termsText:'Terms'},(t,e,n)=>{const o=w[L][v],c=o.bindForm;if(c)return c(t,g,e,D).then(n);var r;o.q.push([[t,g,e,D],n]),r=I,A||(h.body.append(Object.assign(h.createElement('script'),{id:'captcha-provider',async:!0,src:r})),A=!0)});var g,I,D;w[L]=w[L]||{},w[L][v]=w[L][v]||{},w[L][v].q=[],w[L][y]=w[L][y]||{},w[L][y].protect=function(t,e){n(t,void 0,e),T(t)},Object.freeze(w[L][y]),function(t,e,n,w,h,L){const[v,y,A,g]=function(t,e,n){const i=e?o:[],u=t?c:[],d=[...i,...u],f=r(d),m=r(i),_=r(d.filter((([t,e])=>n.includes(e))));return[a(f),a(m),a(_),s()]}(w,h,L),I=t=>{const e=t.target;return e instanceof HTMLFormElement?e:e&&e.form},D=t=>v().includes(t);t.addEventListener('submit',(t=>{const e=I(t);if(!e)return;const n=D(e)&&!e.dataset.hcaptchaBound&&!e.dataset.recaptchaBound,o=_(e),c=g().includes(e)&&(!o||!o.value);(n||c)&&t.preventDefault(),c&&!n&&(function(t){try{if(!f())return;!function(t){const e=f();if(!e)return;const n=_(t);if(!n)return;const o=n.value;o&&e.removeItem(o)}(t);const e=Array.from(Array(32),(()=>Math.random().toString(36)[2])).join('');!function(t,e){_(t)||t.append(Object.assign(document.createElement('input'),{type:'hidden',name:u})),t.elements[u].value=e}(t,e),function(t,e){const n=f();if(!n)return;const o=[...t.querySelectorAll(`input[type='${i}']`)].map((({name:t})=>t)),c=[...d,...o],r={};for(const[a,s]of new FormData(t).entries())c.includes(a)||(r[a]=s);n.setItem(e,JSON.stringify({[m]:1,action:t.action,data:r}))}(t,e)}catch(e){console.error('failed to persist form',e)}}(e),e.submit())}));const S=(t,e)=>{t&&!t.dataset[E]&&(n(t,e.some((e=>e===t))),T(t))};for(const o of['focusin','change'])t.addEventListener(o,(t=>{const e=I(t);D(e)&&S(e,y())}));const B=e.get('form_key'),M=e.get(l),P=B&&M;t.addEventListener('DOMContentLoaded',(()=>{const t=y();if(P)for(const e of t)e.elements[l].value===M&&p(e,B);[...new Set([...A(),...v().filter((t=>'true'===t.dataset.shopifyCaptcha))])].forEach((e=>S(e,t)))}))}(h,new URLSearchParams(w.location.search),n,t,e,['guest_login'])})(!0,!0)}();
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
(function () {var userAgent = navigator.userAgent;var platform = navigator.platform;var maxTouchPoints = navigator.maxTouchPoints || 0;var isIOS = /iPad|iPhone|iPod/.test(platform) || (platform === 'MacIntel' && maxTouchPoints > 1);var isMacSafari = platform.indexOf('Mac') === 0 && /Safari/.test(userAgent) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/.test(userAgent);var isAppleSafari = isIOS || isMacSafari;if (isAppleSafari) {fetch('/sf_private_access_tokens' + location.search).catch(function () {});}function browserMajorVersion(pattern) {var match = userAgent.match(pattern);return match ? parseInt(match[1], 10) : null;}function shouldLoadAutosizesPolyfill() {if (!window.PerformanceObserver?.supportedEntryTypes?.includes('paint')) {return false;}var chromeVersion = browserMajorVersion(/Chrome\/(\d+)/);if (chromeVersion !== null) {return chromeVersion < 126;}var firefoxVersion = browserMajorVersion(/Firefox\/(\d+)/);if (firefoxVersion !== null) {return firefoxVersion < 150;}var safariVersion = isAppleSafari ? browserMajorVersion(/Version\/(\d+).*Safari\//) : null;if (safariVersion !== null) {return safariVersion < 27;}return true;}if (shouldLoadAutosizesPolyfill()) {var autosizesScript = document.createElement('script');autosizesScript.async = true;autosizesScript.crossOrigin = 'anonymous';autosizesScript.src = "//froyaorganics.com/cdn/shopifycloud/storefront/assets/storefront/autosizes-84416378.js";(document.head || document.documentElement).appendChild(autosizesScript);}window.ShopifyAnalytics = window.ShopifyAnalytics || {};window.ShopifyAnalytics.performance = window.ShopifyAnalytics.performance || {};(function () {var LONG_FRAME_THRESHOLD = 50;var longAnimationFrames = [];var activeRafId = null;function collectLongFrames() {var previousTime = null;function rafMonitor(now) {if (activeRafId === null) {return;}var delta = now - previousTime;if (delta > LONG_FRAME_THRESHOLD) {longAnimationFrames.push({startTime: previousTime,endTime: now,});}previousTime = now;activeRafId = requestAnimationFrame(rafMonitor);}previousTime = performance.now();activeRafId = requestAnimationFrame(rafMonitor);}if (!window.PerformanceObserver?.supportedEntryTypes?.includes('long-animation-frame')) {collectLongFrames();var timeoutId = setTimeout(function () {cancelAnimationFrame(activeRafId);}, 10000);window.ShopifyAnalytics.performance.getLongAnimationFrames = function (stopCollection) {if (stopCollection === undefined) {stopCollection = false;}if (stopCollection) {clearTimeout(timeoutId);cancelAnimationFrame(activeRafId);}return longAnimationFrames;};}})();})();
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  window.Shopify = window.Shopify || {};
  window.Shopify.MCP = window.Shopify.MCP || {};
  window.Shopify.MCP.enabled = true;
  window.Shopify.MCP.shop = "volantaromaeu.myshopify.com";
  window.Shopify.MCP.mcpEndpoint = "https:\/\/froyaorganics.com\/api\/mcp";
  window.Shopify.MCP.tools = [{"name":"search_shop_policies_and_faqs","description":"Used to get facts about the stores policies, products, or services.\nSome examples of questions you can ask are:\n  - What is your return policy?\n  - What is your shipping policy?\n  - What is your phone number?\n  - What are your hours of operation?\"\n","inputSchema":{"$schema":"https:\/\/json-schema.org\/draft\/2020-12\/schema","type":"object","properties":{"query":{"type":"string","description":"A natural language query."},"context":{"type":"string","description":"Additional information about the request such as user demographics, mood, location, or other relevant details that could help in tailoring the response appropriately."}},"required":["query"]}}];

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
var d="shopify:webmcp_adapter_loaded",n=Symbol.for("shopify.webmcp_adapter_loading");function s(c,a,{win:r=window,doc:o=document}={}){function p(){try{return r.localStorage.getItem(d)==="true"}catch{return!1}}function l(){try{r.localStorage.setItem(d,"true")}catch{}}function u(){return typeof(o.modelContext||r.navigator?.modelContext)?.registerTool=="function"}function f(){if(r[n]||!u())return;let t=o.head||o.getElementsByTagName("head")[0];if(!t)return;let e=o.createElement("script");e.type="module",e.crossOrigin="anonymous",a&&(e.integrity=a),e.src=c,e.addEventListener("load",l,{once:!0}),e.addEventListener("error",()=>{r[n]=!1},{once:!0}),t.appendChild(e),r[n]=!0}function _(t){let e=o.getElementById("shopify-origin-trials");if(!e||r.__shopifyOriginTrialsDone){t();return}e.addEventListener("load",t,{once:!0}),e.addEventListener("error",t,{once:!0})}function i(){_(()=>r.setTimeout(f,0))}function m(){o.addEventListener("DOMContentLoaded",i,{once:!0})}p()?i():m()}s("https:\/\/cdn.shopify.com\/storefront\/webmcp\/webmcp-0.0.4.js","");

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
var Shopify=Shopify||{};Shopify.PaymentButton=Shopify.PaymentButton||{isStorefrontPortableWallets:!0,init:function(){window.Shopify.PaymentButton.init=function(){};var t=document.createElement("script");t.src="https://froyaorganics.com/cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js",t.type="module",document.head.appendChild(t)}};

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  function portableWalletsHideBuyerConsent(e){var t=document.getElementById("shopify-buyer-consent"),n=document.getElementById("shopify-subscription-policy-button");t&&n&&(t.classList.add("hidden"),t.setAttribute("aria-hidden","true"),n.removeEventListener("click",e))}function portableWalletsShowBuyerConsent(e){var t=document.getElementById("shopify-buyer-consent"),n=document.getElementById("shopify-subscription-policy-button");t&&n&&(t.classList.remove("hidden"),t.removeAttribute("aria-hidden"),n.addEventListener("click",e))}window.Shopify?.PaymentButton&&(window.Shopify.PaymentButton.hideBuyerConsent=portableWalletsHideBuyerConsent,window.Shopify.PaymentButton.showBuyerConsent=portableWalletsShowBuyerConsent);

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
document.addEventListener("DOMContentLoaded",(function(){function t(){return document.querySelector("shopify-accelerated-checkout-cart, shopify-accelerated-checkout")}if(t())Shopify.PaymentButton.init();else{new MutationObserver((function(e,n){t()&&(Shopify.PaymentButton.init(),n.disconnect())})).observe(document.body,{childList:!0,subtree:!0})}}));

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
window.performance && window.performance.mark && window.performance.mark('shopify.content_for_header.end');
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function() {
  const blockedResources = [
    'shop.app',
    'accelerated-checkout',
    'portable-wallets',
    'shopifycloud/portable-wallets'
  ];
  
  function removeUnwantedResources() {
    // Use for...of instead of forEach for better performance
    const links = document.querySelectorAll('link');
    for (const link of links) {
      const href = link.href || '';
      if (blockedResources.some(function(blocked) { return href.includes(blocked); })) {
        if (href.includes('accelerated-checkout') || href.includes('portable-wallets')) {
          const originalHref = href;
          link.remove();
          setTimeout(function() {
            const newLink = document.createElement('link');
            newLink.rel = 'stylesheet';
            newLink.href = originalHref;
            newLink.crossOrigin = 'anonymous';
            document.head.appendChild(newLink);
          }, 5000);
        } else {
          link.remove();
        }
      }
    }
  }
  
  removeUnwantedResources();
  
  if (window.MutationObserver) {
    let mutationTimeout;
    let mutationCount = 0;
    const maxMutations = 5;
    let isProcessing = false;
    
    const processMutations = function(mutations) {
      if (isProcessing || mutationCount >= maxMutations) return;
      isProcessing = true;
      
      for (const mutation of mutations) {
        if (mutationCount >= maxMutations) break;
        
        for (const node of mutation.addedNodes) {
          if (mutationCount >= maxMutations) break;
          if (node.nodeType !== 1 || node.tagName !== 'LINK') continue;
          
          const href = node.href || '';
          if (!blockedResources.some(function(blocked) { return href.includes(blocked); })) continue;
          
          if (href.includes('accelerated-checkout') || href.includes('portable-wallets')) {
            const originalHref = href;
            node.remove();
            setTimeout(function() {
              const newLink = document.createElement('link');
              newLink.rel = 'stylesheet';
              newLink.href = originalHref;
              newLink.crossOrigin = 'anonymous';
              document.head.appendChild(newLink);
            }, 5000);
          } else {
            node.remove();
          }
          mutationCount++;
        }
      }
      
      isProcessing = false;
    };
    
    const observer = new MutationObserver(function(mutations) {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(function() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function() {
            processMutations(mutations);
          }, { timeout: 100 });
        } else {
          processMutations(mutations);
        }
      }, 300);
    });
    
    setTimeout(function() {
      observer.observe(document.head, { childList: true });
      setTimeout(function() {
        observer.disconnect();
      }, 3000);
    }, 1000);
  }
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  var _support = _support || { 'ui': {}, 'user': {} };
  _support.account = "vossabia";

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

window.$th_bundle_addtocart_callback = function(){
  fetch("/cart.js")
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cart, openMiniCart: true }
        })
      );
    });
}

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function () {
  'use strict';
  if (window.__consentmoDataSrcBootstrapInit) return;
  window.__consentmoDataSrcBootstrapInit = true;

  function activateConsentmoDataSrcScripts() {
    if (!window.Shopify || !window.Shopify.shop) return;
    document.querySelectorAll('script[data-src*="consentmo_cookie_consent"]').forEach(function (scriptEl) {
      if (scriptEl.src) return;
      var url = scriptEl.getAttribute('data-src');
      if (url) scriptEl.src = url;
    });
  }
  function scheduleActivation() {
    activateConsentmoDataSrcScripts();
    // Retry on next task so other DCL handlers (lazy-loaders) can finish setting Shopify.shop / data-src first.
    setTimeout(activateConsentmoDataSrcScripts, 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleActivation, { once: true });
  } else {
    scheduleActivation();
  }
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

!function(s) {
  let o = s.createElement('script'), u = s.getElementsByTagName('script')[0];
  o.src = 'https://cdn.aggle.net/oir/oir.min.js';
  o.async = !0, o.setAttribute('oirtyp', '48b1feaa'), o.setAttribute('oirid', 'P7P987M69');
  u.parentNode.insertBefore(o, u);
}(document);

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  {
    const cleanObj = (value) => {
      if (Array.isArray(value)) {
        const cleanedArray = value.map(cleanObj).filter((v) => v !== undefined);
        return cleanedArray.length ? cleanedArray : undefined;
      }
      if (value && typeof value === "object") {
        const cleanedObject = Object.entries(value).reduce((acc, [key, val]) => {
          const cleanedValue = cleanObj(val);
          if (cleanedValue !== undefined && cleanedValue !== null && cleanedValue !== "") {
            acc[key] = cleanedValue;
          }
          return acc;
        }, {});
        return Object.keys(cleanedObject).length ? cleanedObject : undefined;
      }
      if (value === null || value === undefined || value === "") {
        return undefined;
      }
      return value;
    };
    const getCustomer = () => ({
      shopifyCustomerId: "",
      email: "",
      phone: "",
      first_name: null,
      last_name: null,
      lifetime_value: null,
      order_count: null,
      address: {
        street: null,
        city: null,
        state:  null,
        stateCode: null,
        postalCode: "",
        country: "",
        province: "",
        countryCode: "",
      }
    });
    
  }

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
/* ============================================================================
 * Refirm — "Why subscribe?" buy-box module A/B test — VARIANT A
 * ----------------------------------------------------------------------------
 * Inserts a small explainer module (calendar icon + one line of copy) directly
 * ABOVE the one-time vs. subscribe purchase-type selector
 * (fieldset#purchase-type-fieldset) in the main PDP buy box.
 *
 *   [icon]  **Why subscribe?** Most women see their biggest results after a
 *           few weeks of daily use. Subscribing makes staying consistent
 *           effortless
 *
 * Scope: the 18 PDPs listed in HANDLES below (both desktop and mobile).
 * Everything else in the buy box (pricing tiers, selector, CTA, trust icons)
 * is untouched. The sticky add-to-cart form (<s-sticky-form>) renders the
 * same fieldset ID and is deliberately EXCLUDED.
 *
 * The parent form (.c-subscribtion__subscription-form) is a flex column with
 * 15px row-gap, so the module needs no margins — spacing above and below
 * matches the buy box's existing rhythm automatically.
 *
 * Paste into: Intelligems → Variant A → Styles & Javascript → JavaScript box,
 * timing "Immediately". Control = live site → leave the Control boxes empty.
 * Also set Page Targeting to the 18 product URLs (see README.md).
 * ========================================================================== */
(function () {
  'use strict';

  /* ----- CONFIG ----------------------------------------------------------- */

  // Belt-and-braces guard on top of Intelligems Page Targeting: only run on
  // the 18 PDPs in the test scope. Set ENFORCE_HANDLES = false to rely on
  // IG page targeting alone (e.g. if products are added to the test later).
  var ENFORCE_HANDLES = true;
  var HANDLES = [
    'the-complete-under-eye-system',
    'the-complete-acne-system-for-women',
    'the-complete-natural-pharmacy-for-face-body',
    'the-complete-system-for-mature-hair-scalp',
    'arctic-forest-body-soap',
    'magic-wrinkle-eraser-night-balm-1',
    'anti-age-and-insane-glow-day-balm',
    'ultra-potent-dark-circles-eye-bag-remover',
    'ultra-fast-relief-balm-for-dry-itchy-skin-for-face-body',
    'joint-and-muscle-healing-balm',
    'instant-softening-hand-balm',
    'instant-rosacea-acne-redness-stopper',
    'magic-revive-glow-day-balm',
    'ultra-cleanse-revive-face-scrub',
    'shampoo-body-soap',
    'ultra-thickening-growth-rosemary-water',
    'hyper-potent-hair-growth-serum',
    'magic-revive-hair-scalp-shampoo'
  ];

  var COPY_LABEL = 'Why subscribe?';
  var COPY_TEXT  = 'Most women see their biggest results after a few weeks ' +
                   'of daily use. Subscribing makes staying consistent effortless.';

  // True-bold face for the label. Figma (node 3821:60668) sets the label in
  // PP Pangram Sans SEMIBOLD, but no Semibold file exists on the store CDN —
  // the known-good Bold OTF is the closest true-bold asset (ticket: "label in
  // bold"). The theme's own 700 @font-face points at a "_400"-suffixed WOFF2
  // that may contain Regular glyphs (CLAUDE.md known issue #10), so per
  // INTELLIGEMS.md register the Bold OTF under a SEPARATE family name — no
  // conflict, no synthesis.
  var BOLD_FONT_URL =
    'https://cdn.shopify.com/s/files/1/0689/3237/0592/files/swipe-froya-pdp-swipe-6d9cc9b88ba26d9c.otf';

  /* ----- Constants -------------------------------------------------------- */
  var STYLE_ID     = 'ig-why-sub-styles';
  var MODULE_CLASS = 'ig-why-sub';
  var DONE_ATTR    = 'data-ig-why-sub';   // marks a fieldset we've handled
  var FIELDSET_SEL = 'fieldset[id="purchase-type-fieldset"]'; // ID is duplicated
                                          // (main form + sticky form) — never
                                          // use getElementById here.

  /* ----- Scope guard ------------------------------------------------------ */
  function inScope() {
    if (!ENFORCE_HANDLES) return true;
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return false;
    var handle = decodeURIComponent(m[1]).toLowerCase();
    for (var i = 0; i < HANDLES.length; i++) {
      if (HANDLES[i] === handle) return true;
    }
    return false;
  }

  /* ----- Styles — exact Figma spec ---------------------------------------- */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      /* Label bold face — file IS bold, so font-weight stays normal */
      '@font-face{font-family:"PPS Bold";' +
        'src:url("' + BOLD_FONT_URL + '") format("opentype");' +
        'font-weight:normal;font-style:normal;font-display:swap;}',

      /* Card: flex, 12px padding, 12px gap, white bg, 2px #E1E2E2 border */
      '.' + MODULE_CLASS + '{' +
        'display:flex;align-items:flex-start;gap:12px;align-self:stretch;' +
        'width:100%;box-sizing:border-box;margin:0;padding:12px;' +
        'border-radius:5px;border:2px solid #E1E2E2;background:#FFF;' +
        'text-align:left;}',

      /* Icon: 24px circle, never shrinks or stretches */
      '.' + MODULE_CLASS + '__icon{flex:0 0 24px;width:24px;height:24px;}',
      '.' + MODULE_CLASS + '__icon svg{display:block;width:24px;height:24px;}',

      /* Copy: 14px mobile / 16px desktop, 150% line-height, #54585A.
         Weight 500 (Figma span: PP Pangram Sans Medium) — the theme declares
         500 via the known-good Pangram-Medium WOFF2. */
      '.' + MODULE_CLASS + '__text{' +
        'margin:0;color:#54585A;' +
        'font-family:"PP Pangram Sans","Pangram",sans-serif;' +
        'font-size:14px;font-style:normal;font-weight:500;line-height:150%;}',
      '.' + MODULE_CLASS + '__label{' +
        'font-family:"PPS Bold","PP Pangram Sans","Pangram",sans-serif;' +
        'font-weight:normal;color:#54585A;}',
      /* The Bold OTF's "?" hook starts well right of its bounding box, which
         reads as a gap after "subscribe" (Figma's Semibold cut is tighter).
         −0.06em ≈ −1px @16px, verified against Figma in headless Chrome. */
      '.' + MODULE_CLASS + '__qm{margin-left:-0.06em;}',
      '@media (min-width:768px){' +
        '.' + MODULE_CLASS + '__text{font-size:16px;}}'
    ].join('');
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  /* ----- Module build ------------------------------------------------------
   * Icon = Figma's 24px circle + 12.52px calendar composited into one SVG
   * (calendar at x=6, y=5.24 — exact Figma offsets). The original <clipPath> is
   * dropped: nothing draws outside the 12.52px box, and id-referenced defs
   * collide when injected (see INTELLIGEMS.md "SVG ID Collisions").
   * ------------------------------------------------------------------------ */
  var ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="12" fill="#AF8998" fill-opacity="0.2"/>' +
      '<g transform="translate(6 5.24)" stroke="#AF8998" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M4.48828 6.70859C4.78932 6.2365 5.28196 5.89207 5.87558 5.80018C6.83429 5.65177 7.74025 6.21094 8.07132 7.09162"/>' +
        '<path d="M8.29677 6.67285L8.1534 7.18776L7.6427 7.042"/>' +
        '<path d="M8.03165 9.05979C7.73061 9.53188 7.23798 9.87631 6.64435 9.9682C5.68564 10.1166 4.77968 9.55744 4.44861 8.67676"/>' +
        '<path d="M4.22314 9.09499L4.36651 8.58008L4.87722 8.72584"/>' +
        '<path d="M12.0309 3.78689H0.489014V3.11367C0.489014 2.30337 1.1459 1.64648 1.9562 1.64648H10.5637C11.374 1.64648 12.0309 2.30337 12.0309 3.11367V3.78689Z"/>' +
        '<path d="M2.71558 0.538086V1.50817"/>' +
        '<path d="M6.26001 0.538086V1.50817"/>' +
        '<path d="M9.80444 0.538086V1.50817"/>' +
        '<path d="M12.0309 7.99456V3.78711H0.489014V10.5141C0.489014 11.3244 1.1459 11.9813 1.9562 11.9813H10.5637C11.374 11.9813 12.0309 11.3244 12.0309 10.5141V10.4399"/>' +
      '</g>' +
    '</svg>';

  function buildModule() {
    // Wrap a trailing "?" so CSS can pull it closer to the word (see __qm rule)
    var labelHtml = COPY_LABEL.replace(/\?$/,
      '<span class="' + MODULE_CLASS + '__qm">?</span>');
    var el = document.createElement('div');
    el.className = MODULE_CLASS;
    el.innerHTML =
      '<span class="' + MODULE_CLASS + '__icon">' + ICON_SVG + '</span>' +
      '<p class="' + MODULE_CLASS + '__text">' +
        '<strong class="' + MODULE_CLASS + '__label">' + labelHtml + '</strong>' +
        ' ' + COPY_TEXT +   // separator space: label and sentence sit on one line
      '</p>';
    return el;
  }

  /* ----- Placement --------------------------------------------------------
   * Insert before every purchase-type fieldset inside the MAIN product buy
   * box (<s-main-product>). Excludes the sticky form and any other layout
   * that renders the same fieldset ID. Idempotent — safe to re-run.
   * ------------------------------------------------------------------------ */
  function placeModules() {
    var fieldsets = document.querySelectorAll(FIELDSET_SEL);
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      if (fs.getAttribute(DONE_ATTR)) continue;
      if (!fs.closest('s-main-product')) continue;  // main PDP buy box only
      if (fs.closest('s-sticky-form')) continue;    // never the sticky bar
      fs.setAttribute(DONE_ATTR, '1');
      fs.insertAdjacentElement('beforebegin', buildModule());
    }
  }

  /* ----- Init ------------------------------------------------------------- */
  if (!inScope()) return;

  injectStyles();  // CSS at parse time — before DOMContentLoaded

  function run() { injectStyles(); placeModules(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Catch late-rendered buy boxes (IG bundle can run before the section is in
  // the DOM). Debounced; self-disconnects after 10s — the buy box is
  // server-rendered, so anything later than that isn't coming.
  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; placeModules(); }, 150);
  });
  function startObserver() {
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
  setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 10000);
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

(function () {
  'use strict';

  /* ----- Config --------------------------------------------------------- */
  // handle -> that product's 60-day selling plan id (string, numeric).
  var PLANS = {
    // Shared "60-Night Subscribe and Save / Deliver every 60 nights" plan, live on
    // these four products (same id the original Hyper LP test forced).
    'the-complete-under-eye-system': '9530179744', // alt: 9530179744 (ebook bundle)
    'the-complete-acne-system-for-women':          '9530179744',
    'the-complete-natural-pharmacy-for-face-body':  '9530179744',
    'shampoo-body-soap':                            '9530179744',
    'the-complete-system-for-mature-hair-scalp':    '9530179744'
  };
  var PLAN_LABEL = 'DELIVERED EVERY 60 DAYS'; // static text shown in place of the picker
  /* ---------------------------------------------------------------------- */

  var STYLE_ID = 'ig-pdp-60day-no-freq-style';
  var applying = false; // guards the observer against reacting to our own edits
  var domDebounce = null;
  var togglesFetching = false;
  var observer = null;
  // variant id (string) -> forced plan id, learned from the cart so the
  // capture-phase toggle guard can match a checkbox by data-product-id.
  var TARGET_VARIANT_PLANS = {};

  /* ----- Matching helpers ----------------------------------------------- */

  // Return the configured plan for a handle, or null if not targeted / still a
  // placeholder. Tolerates a Shopify "-1" duplicate-handle suffix.
  function planFor(h) {
    if (!h) return null;
    var id = PLANS[h];
    if (!id && h.length > 2 && h.slice(-2) === '-1') id = PLANS[h.slice(0, -2)];
    if (!id || id.indexOf('REPLACE_') === 0) return null;
    return id;
  }

  // Current PDP product handle from the URL (handles locale + collection prefixes).
  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  // True only on one of the five target PDPs (with a real plan configured).
  function onTargetPage() {
    return planFor(currentHandle()) !== null;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /* ===== A. On-page product form ======================================== */

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    // Hide ONLY the original frequency title + radio rows — never the whole
    // fieldset, so the subscription USP bullets (.c-subscribtion__subscription-
    // info-wrapper: "FREE shipping…", "Cancel online anytime") inside it stay put.
    // Style the static plain-text plan label JS injects in their place.
    var css =
      // Collapse the 80px min-height the fieldset reserved for the now-removed
      // radio rows. On these PDPs the USP wrapper renders empty (subscription_note
      // is blank), so without this the static label floats in an ~80px empty box.
      // A little symmetric padding keeps the label off the fieldset edges.
      '.c-subscribtion #selling-plan-fieldset{min-height:0 !important;' +
      'padding-top:6px !important;padding-bottom:6px !important;}' +
      '.c-subscribtion #selling-plan-fieldset > .selling-plan-title,' +
      '.c-subscribtion #selling-plan-fieldset > label{display:none !important;}' +
      '.c-subscribtion #selling-plan-fieldset .ig-static-plan{' +
      // Match the USP wrapper below it: full-width flex column, centered on both
      // axes — text-align alone doesn't center a shrink-wrapped flex item.
      'display:flex !important;flex-direction:column;justify-content:center;' +
      'align-items:center;width:100%;align-self:stretch;text-align:center !important;' +
      "font-family:'Apercu Mono Pro','Apercu Mono',monospace;" +
      'font-size:16px;font-weight:400;line-height:1.3;color:#1f1f1f;margin:0 0 4px;' +
      'text-transform:uppercase;}' +
      // Drop the USP wrapper's top margin so it sits tight under the static label.
      '.c-subscribtion #selling-plan-fieldset .c-subscribtion__subscription-info-wrapper{' +
      'margin-top:0 !important;}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  function neutralizeForm(sub, planId) {
    if (!sub || !planId) return;

    var form =
      sub.querySelector('#selling-plan-form') ||
      sub.querySelector('.js-subscribtion__subscription-form');
    if (!form) return;

    // a) Replace the frequency picker with static text. Remove the original
    //    "Delivered every" title and inject a plain-text plan label in its place,
    //    but KEEP the fieldset so the USP bullets (.c-subscribtion__subscription-
    //    info-wrapper: "FREE shipping over $40", "Cancel online anytime") survive.
    //    The static label also restores the original vertical rhythm: the
    //    fieldset's ~36px padding + the USP wrapper's ~20px margin-top were sized
    //    to sit below the radios, so with nothing there they left an empty gap.
    var fieldset = sub.querySelector('#selling-plan-fieldset');
    if (fieldset) {
      var title = fieldset.querySelector('.selling-plan-title');
      if (title && title.parentNode) title.parentNode.removeChild(title);

      if (!fieldset.querySelector('.ig-static-plan')) {
        var planLabel = document.createElement('div');
        planLabel.className = 'ig-static-plan';
        planLabel.textContent = PLAN_LABEL;
        // Insert above the USP wrapper (where the radios were); the fieldset is
        // hidden on one-time, so this label is subscription-only like the USPs.
        var uspWrap = fieldset.querySelector('.c-subscribtion__subscription-info-wrapper');
        if (uspWrap) {
          fieldset.insertBefore(planLabel, uspWrap);
        } else {
          fieldset.appendChild(planLabel);
        }
      }
    }

    // b) Remove the frequency option ROWS (each radio's <label>) so no radio can
    //    serialize ahead of our hidden input (FormData.get returns the first match
    //    in DOM order). The USP wrapper is a <div> with no radio, so it stays put.
    var radios = form.querySelectorAll(
      'input[name="selling_plan"]:not(.js-default-selling-plan)'
    );
    for (var i = 0; i < radios.length; i++) {
      var row = radios[i].closest('label') || radios[i];
      if (row && row.parentNode) row.parentNode.removeChild(row);
    }

    // c) Ensure exactly one authoritative hidden plan input.
    var hidden = form.querySelector('input.js-default-selling-plan');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'selling_plan';
      hidden.className = 'js-default-selling-plan';
      form.appendChild(hidden);
    }
    hidden.value = planId;
    hidden.disabled = false;

    // d) Keep the web component's own default in sync.
    sub.setAttribute('data-default-selling-plan', planId);
    try { sub.defaultSellingPlan = planId; } catch (e) {}
  }

  /* ===== C. Mini-cart quick-add cards =================================== */

  function stampQuickAddCards() {
    var forms = document.querySelectorAll('#mini-cart .drawer__product-form');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var cta = form.querySelector('.drawer__product-form__cta');
      if (!cta) continue;
      var planId =
        planFor(cta.getAttribute('data-product-handle')) ||
        planFor(cta.getAttribute('data-gift-trigger'));
      if (!planId) continue;

      // selling_plan — create if the card never rendered one (non-system type).
      var sp = form.querySelector('input[name="selling_plan"]');
      if (!sp) {
        sp = document.createElement('input');
        sp.type = 'hidden';
        sp.name = 'selling_plan';
        sp.className = 'drawer__product-form__selling-plan';
        form.appendChild(sp);
      }
      sp.value = planId;

      // purchase_type=subscription — required so the gift extension keeps the
      // plan (it drops selling_plan for anything that isn't "subscription").
      var pt = form.querySelector('input[name="purchase_type"]');
      if (!pt) {
        pt = document.createElement('input');
        pt.type = 'hidden';
        pt.name = 'purchase_type';
        form.appendChild(pt);
      }
      pt.value = 'subscription';
    }
  }

  /* ===== B. Mini-cart subscribe toggle ================================== */

  function stampSubscribeToggles() {
    if (togglesFetching) return;
    // Only worth a cart fetch when the drawer has toggles rendered.
    if (!document.querySelector('#mini-cart .subscription-checkbox')) return;
    togglesFetching = true;

    fetchCart()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        cart.items.forEach(function (item, index) {
          var planId = planFor(item.handle);
          if (!planId) return;
          TARGET_VARIANT_PLANS[String(item.variant_id)] = planId;

          var checkbox = document.querySelector(
            '#mini-cart .subscription-checkbox[data-line="' + (index + 1) + '"]'
          );
          if (!checkbox) return;
          // getRestoreSellingPlanId() reads data-subscription-plan-id FIRST,
          // then data-selling-plan-id. The server-rendered restore id falls
          // back to the 6-week first allocation once a line isn't currently a
          // subscription (i.e. right after toggle-off), so force BOTH to 60-day.
          checkbox.dataset.subscriptionPlanId = planId;     // primary on toggle-ON
          checkbox.dataset.sellingPlanId = planId;          // fallback + saved plan
          checkbox.setAttribute('data-ig-force-plan', planId); // race-guard
        });
      })
      .catch(function () {})
      .then(function () { togglesFetching = false; });
  }

  // Capture-phase: fires BEFORE the theme's bubble-phase delegated handler, so
  // the rewritten plan is what gets sent to /cart/change.js. Match by the
  // stamped marker OR by a variant id we've already seen for a target product.
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.classList || !cb.classList.contains('subscription-checkbox')) return;
    if (!cb.checked) return;
    var planId =
      cb.getAttribute('data-ig-force-plan') ||
      TARGET_VARIANT_PLANS[String(cb.dataset.productId)];
    if (planId) {
      // Both attrs, synchronously, before the bubble-phase _updateSubscription
      // runs — getRestoreSellingPlanId() prefers data-subscription-plan-id.
      cb.dataset.subscriptionPlanId = planId;
      cb.dataset.sellingPlanId = planId;
    }
  }, true);

  /* ===== Passes + wiring ================================================ */

  // Synchronous DOM work — on-page form (A) + quick-add cards (C).
  function domPass() {
    if (!onTargetPage()) {
      // Still stamp quick-add cards: the mini-cart can recommend a target
      // product even when the current PDP isn't one of the five.
      stampQuickAddCards();
      return;
    }
    injectStyles();
    applying = true;
    var planId = planFor(currentHandle()); // this PDP's product
    var subs = document.querySelectorAll('c-subscription');
    for (var i = 0; i < subs.length; i++) neutralizeForm(subs[i], planId);
    stampQuickAddCards();
    applying = false;
  }

  // Async cart work — subscribe toggles (B). Safe on any page (matches by handle).
  function cartPass() {
    stampSubscribeToggles();
  }

  function scheduleDomPass() {
    if (applying) return;
    if (domDebounce) clearTimeout(domDebounce);
    domDebounce = setTimeout(domPass, 80);
  }

  function startObserver() {
    if (observer || !window.MutationObserver) return;
    observer = new MutationObserver(function () { scheduleDomPass(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function bindCartEvents() {
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      document.documentElement.addEventListener(name, function () {
        setTimeout(function () { domPass(); cartPass(); }, 120);
      });
    });
  }

  function pollEarly() {
    // Bounded poll so a late-rendered form/checkbox isn't missed if a single
    // querySelector loses the race against the bundle.
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      domPass();
      cartPass();
      if (tries >= 25) clearInterval(t); // ~5s
    }, 200);
  }

  function init() {
    if (onTargetPage()) injectStyles();
    domPass();
    cartPass();
    startObserver();
    bindCartEvents();
    pollEarly();
  }

  /* CSS first (no DOM dependency), then init when the DOM is ready. */
  if (onTargetPage()) injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
/* ============================================================================
 * Refirm — PDP Image-Gallery A/B test  (Under-Eye System)
 * GROUP : Variant
 * PAGE  : /products/the-complete-under-eye-system  (this PDP only)
 * ----------------------------------------------------------------------------
 * Replaces the native "stage" gallery (product.media) with a fixed 11-item set:
 *   1 region-specific first image (warehouse "Ships From" badge baked into the
 *   art) + IMG_2…IMG_10 + a closing video. Adds a subtle border to non-active
 *   thumbnails and a Figma play-button overlay on the video.
 *
 * REGION (warehouse) — IG-only, resolved CLIENT-SIDE, no theme block. Reads
 *   window.Shopify.country (same source the theme's region-detector uses) and
 *   maps it to the same buckets as the LP/homepage hero test:
 *       Australia                      -> 'aus' -> Sydney   (IMG_1_SYD)
 *       United Kingdom + EU countries  -> 'eu'  -> Amsterdam(IMG_1__AMS)
 *       US + everything else (default) -> 'us'  -> Florida  (IMG_1_FLO)
 *   QA override: set window.__igGalleryRegion = 'aus' | 'eu' | 'us' BEFORE this
 *   runs (also honors window.__igHeroRegion if a server block ever sets it).
 *
 * The injected chrome mirrors the theme's native stage-gallery CSS 1:1, so the
 * ONLY differences vs. Control are: the image set, the regional first image, the
 * non-active thumbnail border, and the video play-button overlay.
 *
 * Paste into Intelligems -> Variant -> Modifications -> Styles & Javascript ->
 * JavaScript box. Timing: Immediately.
 * ========================================================================== */
(function () {
  'use strict';

  /* ── Page guard — this PDP only (locale prefix safe, no sub-handle match) ── */
  var PRODUCT_HANDLE = 'the-complete-under-eye-system';
  if (!new RegExp('(^|/)products/' + PRODUCT_HANDLE + '(/|$)').test(location.pathname)) return;

  /* Tell the theme anti-flicker block the variant is running, so it keeps the
     gallery hidden until OUR swap paints (no flash of the original) instead of
     revealing on a blind timer. Set before anything async. */
  window.__igMwgActive = true;

  /* =====================================================================
     CONFIG — edit values here
     ===================================================================== */
  var CDN = 'https://cdn.shopify.com/s/files/1/0473/9999/3493/files/';

  /* Region-specific first image (warehouse badge baked in). */
  var REGION_IMAGE = {
    aus: CDN + 'IMG_1_SYD.png?v=1782462683',
    eu:  CDN + 'IMG_1__AMS.png?v=1782462683',
    us:  CDN + 'IMG_1_FLO.png?v=1782462683'
  };

  /* Shared images 2–10 (same for every region), in gallery order. */
  var SHARED_IMAGES = [
    CDN + 'IMG_2.png?v=1782462708',
    CDN + 'IMG_3.png?v=1782462705',
    CDN + 'IMG_4_51e90354-5a8f-4469-9287-d1746d6736e0.png?v=1782462735',
    CDN + 'IMG_5.png?v=1782462686',
    CDN + 'IMG_6.png?v=1782462701',
    CDN + 'IMG_7.png?v=1782462723',
    CDN + 'IMG_8.png?v=1782462709',
    CDN + 'IMG_9.png?v=1782462637',
    CDN + 'IMG_10.png?v=1782462723'
  ];

  /* Closing video + its poster (Figma "VIDEO THUMBNAIL"). */
  var VIDEO = {
    url:    'https://cdn.shopify.com/videos/c/o/v/544fd91b776740009a0ea9840bce6aeb.mp4',
    poster: CDN + 'VIDEO_THUMBNAIL.png?v=1782462655'
  };

  /* Thumbnail borders. Non-active = subtle light-gray hairline (visible against
     the white-background gallery images). Active keeps the theme's terracotta. */
  var THUMB_BORDER_INACTIVE = '0.5px solid #DFDFDF';
  var THUMB_BORDER_ACTIVE   = '2px solid #7c2350';

  /* CDN resize width for main image / thumbnails (display px × DPR). */
  var MAIN_IMG_WIDTH = 1000; // ~500px display × 2
  var THUMB_IMG_WIDTH = 180; // ~66px display × ~2.7

  var STYLE_ID   = 'ig-mwg-gallery-style';
  var DONE_ATTR  = 'data-ig-mwg';
  var ROOT_CLASS = 'ig-mwg-scope';
  var READY_CLASS = 'ig-mwg-ready';

  /* =====================================================================
     SVG — nav arrow (theme's) + Figma play button (exact geometry)
     ===================================================================== */
  var ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" viewBox="0 0 17 21" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.39538 0.229918C4.46901 0.157038 4.55648 0.0992146 4.65278 0.0597614C4.74908 0.0203083 4.85232 0 4.95658 0C5.06084 0 5.16408 0.0203083 5.26038 0.0597614C5.35668 0.0992146 5.44415 0.157038 5.51778 0.229918L15.0296 9.62112C15.1035 9.69382 15.162 9.78018 15.202 9.87526C15.2419 9.97034 15.2625 10.0723 15.2625 10.1752C15.2625 10.2781 15.2419 10.3801 15.202 10.4752C15.162 10.5702 15.1035 10.6566 15.0296 10.7293L5.51778 20.1205C5.36894 20.2674 5.16707 20.35 4.95658 20.35C4.74609 20.35 4.54422 20.2674 4.39538 20.1205C4.24654 19.9735 4.16292 19.7742 4.16292 19.5664C4.16292 19.3586 4.24654 19.1593 4.39538 19.0123L13.3476 10.1752L4.39538 1.33808C4.32156 1.26538 4.26299 1.17902 4.22303 1.08394C4.18307 0.988866 4.16251 0.886939 4.16251 0.784C4.16251 0.68106 4.18307 0.579133 4.22303 0.484054C4.26299 0.388976 4.32156 0.302615 4.39538 0.229918Z" fill="white"/></svg>';

  /* Figma "Group 1484582091": 74% #D9D9D9 circle + white triangle.
     viewBox is the circle's bounding box; the soft shadow is applied via CSS. */
  var PLAY_SVG = '<svg viewBox="0 0 225.1 225.1" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true"><circle cx="112.548" cy="112.548" r="112.548" fill="#D9D9D9" fill-opacity="0.74"/><path d="M167.177 112.219L84.74 159.814L84.74 64.6244L167.177 112.219Z" fill="#fff"/></svg>';

  /* =====================================================================
     Region detection (client-side; mirrors region-detector buckets)
     ===================================================================== */
  var EU_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];

  function detectRegion() {
    var forced = (window.__igGalleryRegion || window.__igHeroRegion || '').toString().toLowerCase();
    if (forced === 'aus' || forced === 'eu' || forced === 'us') return forced;
    var country = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (country === 'AU') return 'aus';
    if (country === 'GB' || EU_COUNTRIES.indexOf(country) !== -1) return 'eu';
    return 'us';
  }

  /* =====================================================================
     Build the media list (regional first image + shared + video last)
     ===================================================================== */
  var region = detectRegion();
  var MEDIA = [{ type: 'image', url: REGION_IMAGE[region] || REGION_IMAGE.us }];
  for (var s = 0; s < SHARED_IMAGES.length; s++) MEDIA.push({ type: 'image', url: SHARED_IMAGES[s] });
  MEDIA.push({ type: 'video', url: VIDEO.url, poster: VIDEO.poster });

  /* =====================================================================
     Helpers
     ===================================================================== */
  function cdnResize(url, width) {
    if (!url || url.indexOf('.mp4') !== -1) return url;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  function trackEvent(index) {
    // Lightweight breadcrumb for any IG/GTM listener — harmless if unused.
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: 'gallery_thumbnail_click', properties: { imageIndex: index } });
  }

  /* =====================================================================
     CSS — mirrors the native stage-gallery values 1:1 (+ play button)
     ===================================================================== */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      /* Anti-flicker — hide the wrapper until our gallery is built. */
      '.s-main-product__gallery-wrapper { opacity: 0 !important; transition: opacity .2s ease; }',
      '.s-main-product__gallery-wrapper.' + READY_CLASS + ' { opacity: 1 !important; }',

      /* Main stage (= .s-main-product__gallery--stage). */
      '.ig-mwg__main { position: relative; width: 100%; aspect-ratio: 1 / 1; overflow: hidden; border-radius: 4.789px; background: #f8f8f8; }',
      '@media screen and (min-width: 768px) { .ig-mwg__main { max-width: 499.5px; margin: 0 auto; } }',
      '.ig-mwg__main-img { display: block; width: 100%; height: 100%; object-fit: contain; }',
      '.ig-mwg__main-video { display: none; width: 100%; height: 100%; position: absolute; inset: 0; object-fit: cover; object-position: center center; background: #000; }',

      /* Play-button overlay on the video poster (Figma: 20.8% of stage, 20% scrim). */
      '.ig-mwg__play { position: absolute; inset: 0; z-index: 3; display: none; align-items: center; justify-content: center; cursor: pointer; background: rgba(0, 0, 0, .2); }',
      '.ig-mwg__play.is-visible { display: flex; }',
      '.ig-mwg__play svg { width: 20.84%; height: auto; filter: drop-shadow(0 0 8.5px rgba(0, 0, 0, .25)); }',

      /* Overlay nav arrows (= .s-main-product__stage-arrow). */
      '.ig-mwg__arrow { position: absolute; top: 50%; transform: translateY(-50%); z-index: 4; display: flex; align-items: center; justify-content: center; padding: 8.325px; border: none; border-radius: 50%; background: rgba(0, 0, 0, .4); cursor: pointer; transition: opacity .15s ease; }',
      '.ig-mwg__arrow:hover { opacity: .8; }',
      '.ig-mwg__arrow svg { display: block; width: 16.65px; height: 16.65px; }',
      '.ig-mwg__arrow--prev { left: 9.25px; }',
      '.ig-mwg__arrow--prev svg { transform: scaleX(-1); }',
      '.ig-mwg__arrow--next { right: 9.25px; }',
      '@media screen and (max-width: 768px) {',
      '  .ig-mwg__arrow { padding: 6.167px; }',
      '  .ig-mwg__arrow svg { width: 12.333px; height: 12.333px; }',
      '  .ig-mwg__arrow--prev { left: 6.85px; }',
      '  .ig-mwg__arrow--next { right: 6.85px; }',
      '}',

      /* Thumbnail strip (= .s-main-product__thumbnails--strip). */
      '.ig-mwg__thumbs { display: flex; flex-direction: row; gap: 6px; margin: 10px 0 0; padding: 2px; overflow-x: auto; overflow-y: hidden; -webkit-overflow-scrolling: touch; scrollbar-width: none; }',
      '@media screen and (min-width: 768px) { .ig-mwg__thumbs { max-width: 500px; } }',
      '.ig-mwg__thumbs::-webkit-scrollbar { display: none; }',

      /* Thumbnail (= .s-main-product__thumbnail) + new non-active border. */
      '.ig-mwg__thumb { position: relative; flex: 0 0 66px; width: 66px; max-width: 66px; height: 66px; margin: 0; border-radius: 4px; overflow: hidden; cursor: pointer; aspect-ratio: 1 / 1; }',
      '.ig-mwg__thumb::after { content: ""; position: absolute; inset: 0; z-index: 3; border: ' + THUMB_BORDER_INACTIVE + '; border-radius: 4px; pointer-events: none; transition: border-color .15s ease; }',
      '.ig-mwg__thumb.is-active::after { border: ' + THUMB_BORDER_ACTIVE + '; }',
      '.ig-mwg__thumb img { display: block; width: 100%; height: 100%; object-fit: cover; pointer-events: none; }',

      /* Small play badge on the video thumbnail. */
      '.ig-mwg__thumb-play { position: absolute; inset: 0; z-index: 2; display: flex; align-items: center; justify-content: center; pointer-events: none; }',
      '.ig-mwg__thumb-play svg { width: 40%; height: auto; filter: drop-shadow(0 0 2px rgba(0, 0, 0, .3)); }',

      /* Belt-and-suspenders: hide any native stage chrome that survives. */
      '.' + ROOT_CLASS + ' .s-main-product__stage-arrow { display: none !important; }'
    ].join('\n');
    (document.head || document.documentElement).appendChild(style);
  }

  /* =====================================================================
     Neutralise the native gallery controller (stage + legacy Flickity)
     ===================================================================== */
  function blockNativeGallery() {
    var component = document.querySelector('s-main-product');
    if (!component) return;
    // Prevent (re)initialisation.
    component.initStageGallery = function () {};
    component.initializeSliders = function () {};
    // Tear down listeners if it already initialised.
    if (typeof component.destroyStageGallery === 'function') {
      try { component.destroyStageGallery(); } catch (e) {}
    }
  }

  /* =====================================================================
     Build the replacement gallery
     ===================================================================== */
  function buildGallery() {
    var wrapper = document.querySelector('.s-main-product__gallery-wrapper');
    if (!wrapper) return false;
    if (wrapper.getAttribute(DONE_ATTR)) return true;

    blockNativeGallery();
    wrapper.setAttribute(DONE_ATTR, '1');

    var component = wrapper.closest('s-main-product');
    if (component) component.classList.add(ROOT_CLASS);

    // Preserve the LIVE discount/bestseller tags node (keeps its JS bindings).
    var tagsEl = wrapper.querySelector('.s-main-product__gallery-tags');
    if (tagsEl && tagsEl.parentNode) tagsEl.parentNode.removeChild(tagsEl);

    // Preserve View Ingredients button + modal (theme renders these inside wrapper).
    var ingredientsBtn = wrapper.querySelector('.js-view-ingredients');
    var ingredientsModal = wrapper.querySelector('#ingredients-modal');
    if (ingredientsBtn && ingredientsBtn.parentNode) ingredientsBtn.parentNode.removeChild(ingredientsBtn);
    if (ingredientsModal && ingredientsModal.parentNode) ingredientsModal.parentNode.removeChild(ingredientsModal);

    var altBase = 'The Complete System for Under-Eyes\'s Skin';
    var currentIndex = 0;

    // ── Main stage ──
    var html = '<div class="ig-mwg__main">' +
      '<img class="ig-mwg__main-img" src="' + cdnResize(MEDIA[0].url, MAIN_IMG_WIDTH) + '" ' +
        'alt="' + altBase + '" width="500" height="500" />' +
      '<div class="ig-mwg__play" role="button" tabindex="0" aria-label="Play video">' + PLAY_SVG + '</div>' +
      '<video class="ig-mwg__main-video" playsinline preload="none"></video>' +
      '<button type="button" class="ig-mwg__arrow ig-mwg__arrow--prev" aria-label="Previous image">' + ARROW_SVG + '</button>' +
      '<button type="button" class="ig-mwg__arrow ig-mwg__arrow--next" aria-label="Next image">' + ARROW_SVG + '</button>' +
      '</div>';

    // ── Thumbnail strip ──
    html += '<div class="ig-mwg__thumbs">';
    for (var i = 0; i < MEDIA.length; i++) {
      var isVideo = MEDIA[i].type === 'video';
      var thumbSrc = cdnResize(isVideo ? MEDIA[i].poster : MEDIA[i].url, THUMB_IMG_WIDTH);
      var label = isVideo ? 'Play video' : 'View image ' + (i + 1) + ' of ' + MEDIA.length;
      html += '<div class="ig-mwg__thumb' + (i === 0 ? ' is-active' : '') + '" data-index="' + i + '" ' +
        'role="button" aria-label="' + label + '">' +
        '<img src="' + thumbSrc + '" alt="" width="66" height="66" loading="lazy" decoding="async" />' +
        (isVideo ? '<span class="ig-mwg__thumb-play">' + PLAY_SVG + '</span>' : '') +
        '</div>';
    }
    html += '</div>';

    wrapper.innerHTML = html;

    // Re-attach the live tags node inside the (position:relative) main stage.
    var mainEl = wrapper.querySelector('.ig-mwg__main');
    if (tagsEl && mainEl) mainEl.insertBefore(tagsEl, mainEl.firstChild);

    // Re-attach View Ingredients UI below thumbnail strip (original theme order).
    if (ingredientsBtn) wrapper.appendChild(ingredientsBtn);
    if (ingredientsModal) wrapper.appendChild(ingredientsModal);

    // ── Cache refs ──
    var mainImg = wrapper.querySelector('.ig-mwg__main-img');
    var mainVideo = wrapper.querySelector('.ig-mwg__main-video');
    var playOverlay = wrapper.querySelector('.ig-mwg__play');
    var thumbContainer = wrapper.querySelector('.ig-mwg__thumbs');
    var thumbs = wrapper.querySelectorAll('.ig-mwg__thumb');
    var prevArrow = wrapper.querySelector('.ig-mwg__arrow--prev');
    var nextArrow = wrapper.querySelector('.ig-mwg__arrow--next');

    // ── Show image / video poster in the main stage ──
    function showMedia(index) {
      var item = MEDIA[index];

      // Always reset the video element when switching slides.
      if (!mainVideo.paused) mainVideo.pause();
      mainVideo.style.display = 'none';
      mainVideo.controls = false;
      mainVideo.removeAttribute('src');

      if (item.type === 'video') {
        mainImg.src = cdnResize(item.poster, MAIN_IMG_WIDTH);
        mainImg.style.visibility = 'visible';
        playOverlay.classList.add('is-visible');
        mainVideo.src = item.url; // armed for playback on click
      } else {
        mainImg.src = cdnResize(item.url, MAIN_IMG_WIDTH);
        mainImg.style.visibility = 'visible';
        playOverlay.classList.remove('is-visible');
      }
    }

    // ── Start playback ──
    function playVideo() {
      if (MEDIA[currentIndex].type !== 'video') return;
      playOverlay.classList.remove('is-visible');
      mainImg.style.visibility = 'hidden';
      mainVideo.controls = true;
      mainVideo.style.display = 'block';
      var p = mainVideo.play();
      if (p && p.catch) p.catch(function () {});
    }
    playOverlay.addEventListener('click', playVideo);
    playOverlay.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); playVideo(); }
    });

    // ── Navigate ──
    function goToMedia(index) {
      if (index < 0) index = MEDIA.length - 1;
      if (index >= MEDIA.length) index = 0;
      currentIndex = index;

      showMedia(currentIndex);

      for (var j = 0; j < thumbs.length; j++) {
        thumbs[j].classList.toggle('is-active', j === currentIndex);
      }

      // Keep active thumb in view (scrollLeft only — never scrollIntoView).
      var thumbEl = thumbs[currentIndex];
      if (thumbEl) {
        thumbContainer.scrollTo({
          left: thumbEl.offsetLeft - (thumbContainer.offsetWidth / 2) + (thumbEl.offsetWidth / 2),
          behavior: 'smooth'
        });
      }
    }

    prevArrow.addEventListener('click', function () { goToMedia(currentIndex - 1); });
    nextArrow.addEventListener('click', function () { goToMedia(currentIndex + 1); });

    thumbContainer.addEventListener('click', function (e) {
      var thumb = e.target.closest('.ig-mwg__thumb');
      if (!thumb) return;
      var index = parseInt(thumb.getAttribute('data-index'), 10);
      goToMedia(index);
      trackEvent(index);
    });

    // ── Touch swipe on the main stage ──
    var touchStartX = 0, touchDelta = 0;
    mainEl.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX; touchDelta = 0;
    }, { passive: true });
    mainEl.addEventListener('touchmove', function (e) {
      touchDelta = e.touches[0].clientX - touchStartX;
    }, { passive: true });
    mainEl.addEventListener('touchend', function () {
      if (Math.abs(touchDelta) > 40) goToMedia(currentIndex + (touchDelta > 0 ? -1 : 1));
    });

    // ── Reveal (with hard safety fallback) ──
    function reveal() { wrapper.classList.add(READY_CLASS); }
    if (mainImg.complete && mainImg.naturalWidth > 0) reveal();
    else { mainImg.onload = reveal; mainImg.onerror = reveal; }
    setTimeout(reveal, 2000);

    // ── Preload remaining stage images during browser idle time so
    //    navigation is instant without competing with the critical render
    //    path (LCP/INP). Browser negotiates webp/avif, so these are light. ──
    function preloadRest() {
      for (var p = 1; p < MEDIA.length; p++) {
        if (MEDIA[p].type === 'image') { var im = new Image(); im.src = cdnResize(MEDIA[p].url, MAIN_IMG_WIDTH); }
      }
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(preloadRest, { timeout: 2500 });
    else setTimeout(preloadRest, 800);

    return true;
  }

  /* =====================================================================
     Init — styles immediately, build when the gallery exists (bounded retry)
     ===================================================================== */
  injectStyles();
  blockNativeGallery();

  var tries = 0;
  function tick() {
    blockNativeGallery();
    if (buildGallery()) return;
    if (++tries < 60) setTimeout(tick, 100); // up to ~6s for late DOM
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
/* ============================================================================
 * Refirm — Low-Stock Notice A/B test — VARIANT A
 * ----------------------------------------------------------------------------
 * Replaces the static buy-box warning
 *     "This product sold out twelve times last year. We encourage you to take
 *      advantage of the limited sale and buy now."   (.c-subscribtion__warning-wrapper)
 * with a daily, per-product low-stock banner placed BELOW the trust icons
 * (.s-main-product__product-icons / .s-featured-product__product-icons).
 *
 * Runs everywhere a Refirm buy box renders — PDP, the mature-skin landing pages,
 * and the homepage featured buy box. The number is a deterministic hash of the
 * product HANDLE + today's date (store timezone), so the SAME product shows the
 * SAME number on every page, every market, all day — and rolls over at midnight.
 * It is NOT real inventory.
 *
 * Paste into: Intelligems → Variant A → Styles & Javascript → JavaScript box.
 * The script self-injects its CSS. For the cleanest anti-flicker you may ALSO
 * paste low-stock.css into the same variant's CSS box (it hides the old warning
 * a few ms earlier). Control = live site → leave the Control boxes empty.
 * ========================================================================== */
(function () {
  'use strict';

  /* ----- CONFIG — flag if wrong ------------------------------------------ */

  // Store timezone for the daily rollover (so every visitor worldwide sees the
  // same number on the same store-day). Refirm's store is US Eastern (GMT-5 / EST;
  // currently GMT-4 under daylight saving). 'America/New_York' rolls the number
  // at midnight Eastern year-round and auto-handles the DST shift. Use 'Etc/GMT+5'
  // instead only if you want a fixed −5 offset with no daylight-saving change.
  var STORE_TIMEZONE = 'America/New_York';

  // Copy. The Figma reads "Low Stock: only X left". The written scope says
  // "only X items left" — set ADD_ITEMS = true to use the "items" wording.
  var ADD_ITEMS = false;

  // Spacing between the trust-icons row and the banner (design rhythm = 13px).
  var GAP_FROM_ICONS = '13px';

  // Products that should never show the low-stock banner.
  var EXCLUDED_HANDLES = ['refirm-ebook', 'refirm-gift-card'];

  /* ----- Constants -------------------------------------------------------- */
  var STYLE_ID      = 'ig-low-stock-styles';
  var BANNER_CLASS  = 'ig-low-stock';
  var PROCESSED_ATTR = 'data-ig-low-stock';    // marks an icons row we've handled
  var BB_DONE_ATTR   = 'data-ig-low-stock-bb'; // marks a buy box that has a banner
  var STOCK_MIN = 50;
  var STOCK_MAX = 199;

  // Trust-icons rows (primary anchor) and the main buy-box sections / forms.
  var ICONS_SEL        = '.s-main-product__product-icons,.s-featured-product__product-icons';
  var MAIN_SECTION_SEL = 's-main-product,s-featured-product';
  var BUYBOX_SEL       = 'c-subscription[data-product-handle],form.custom-product-form[data-product-handle]';
  var CTA_SEL          = '.c-subscribtion__add-to-cart,.c-product-form__add-to-cart';

  /* ----- Number logic ----------------------------------------------------- */

  // Deterministic hash (spec algorithm). Seed = "<handle>-<YYYY-MM-DD>".
  // Same seed -> same integer in [STOCK_MIN, STOCK_MAX], in every browser.
  function getStockNumber(seed) {
    var hash = 0;
    for (var i = 0; i < seed.length; i++) {
      hash = (hash * 31 + seed.charCodeAt(i)) & 0xffffffff;
    }
    var range = STOCK_MAX - STOCK_MIN + 1; // 150 possible values
    return STOCK_MIN + (Math.abs(hash) % range);
  }

  // Today's date as YYYY-MM-DD in the STORE timezone (not the visitor's), so the
  // number is identical for all visitors on a given store-day.
  function storeDateString() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: STORE_TIMEZONE,
        year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10); // UTC fallback
    }
  }

  var DATE_STR = storeDateString();

  function stockNumberForHandle(handle) {
    return getStockNumber(handle + '-' + DATE_STR);
  }

  /* ----- Styles (anti-flicker hide + banner) ------------------------------ */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      /* Anti-flicker: remove the old urgency warning immediately, everywhere
         a buy box renders (variant traffic only — this JS is variant-scoped). */
      '.c-subscribtion__warning-wrapper{display:none!important;}',

      /* Banner — exact Figma spec */
      '.' + BANNER_CLASS + '{' +
        'display:flex;flex-direction:column;justify-content:center;align-items:center;' +
        'gap:13px;align-self:stretch;width:100%;box-sizing:border-box;' +
        'margin-top:' + GAP_FROM_ICONS + ';padding:16px 15px;border-radius:5px;' +
        'background:linear-gradient(0deg,#F3EDF0 0%,#F3EDF0 100%),#FEF4ED;}',
      '.' + BANNER_CLASS + '__inner{' +
        'display:flex;flex-wrap:wrap;align-items:baseline;justify-content:center;' +
        'gap:6px;text-align:center;}',
      '.' + BANNER_CLASS + '__flame{font-size:16px;line-height:1;}',
      '.' + BANNER_CLASS + '__text{' +
        'color:#1F1F1F;font-family:"PP Pangram Sans","Pangram",sans-serif;' +
        'font-size:16px;font-style:normal;font-weight:500;line-height:normal;}',
      '.' + BANNER_CLASS + '__count{' +
        'color:#7c2350;font-family:"PP Pangram Sans","Pangram",sans-serif;' +
        'font-size:16px;font-style:normal;font-weight:500;line-height:normal;}'
    ].join('');
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  /* ----- Handle resolution ------------------------------------------------ */

  // Nearest buy box ([data-product-handle]) for a given element, walking up.
  function buyBoxForAnchor(anchor) {
    var node = anchor;
    while (node && node !== document.body) {
      var bb = node.querySelector(BUYBOX_SEL);
      if (bb) return bb;
      node = node.parentElement;
    }
    return null;
  }

  // Resolve the product handle.
  //  1. On a product URL (/products/<handle>), the MAIN trust-icons row is the
  //     URL product — authoritative, immune to any upsell/bundle form ordering.
  //  2. Otherwise use the buy box's own data-product-handle (scopes each banner
  //     to its own product, so a page with several products is handled per-box).
  function handleFor(iconsRow, bb) {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    var urlHandle = m ? decodeURIComponent(m[1]) : null;
    if (urlHandle && iconsRow && iconsRow.classList &&
        iconsRow.classList.contains('s-main-product__product-icons')) {
      return urlHandle;
    }
    if (bb) {
      var h = bb.getAttribute('data-product-handle');
      if (h) return h;
    }
    return urlHandle; // last-ditch
  }

  /* ----- Banner build + placement ----------------------------------------- */
  function buildBanner(num) {
    var banner = document.createElement('div');
    banner.className = BANNER_CLASS;
    banner.setAttribute('role', 'status');
    var tail = ADD_ITEMS ? ' items left' : ' left';
    banner.innerHTML =
      '<div class="' + BANNER_CLASS + '__inner">' +
        '<span class="' + BANNER_CLASS + '__flame" aria-hidden="true">🔥</span>' +
        '<span class="' + BANNER_CLASS + '__text">Low Stock: only ' +
          '<span class="' + BANNER_CLASS + '__count">' + num + '</span>' + tail +
        '</span>' +
      '</div>';
    return banner;
  }

  function placeBanners() {
    // Pass 1 — primary: below the trust-icons row.
    var rows = document.querySelectorAll(ICONS_SEL);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.getAttribute(PROCESSED_ATTR)) continue;          // idempotent
      var bb = buyBoxForAnchor(row);
      var handle = handleFor(row, bb);
      if (!handle) continue;
      if (EXCLUDED_HANDLES.indexOf(handle) !== -1) continue;
      row.setAttribute(PROCESSED_ATTR, '1');
      if (bb) bb.setAttribute(BB_DONE_ATTR, '1');
      row.insertAdjacentElement('afterend', buildBanner(stockNumberForHandle(handle)));
    }

    // Pass 2 — fallback: a MAIN buy-box section with NO icons row → below the CTA.
    // Scoped to <s-main-product>/<s-featured-product>, which excludes the sticky
    // add-to-cart bar (<s-sticky-form>) and unrelated upsell mini-forms.
    var sections = document.querySelectorAll(MAIN_SECTION_SEL);
    for (var s = 0; s < sections.length; s++) {
      var section = sections[s];
      if (section.querySelector(ICONS_SEL)) continue;          // has icons -> pass 1
      var box = section.querySelector(BUYBOX_SEL);
      if (!box || box.getAttribute(BB_DONE_ATTR)) continue;
      if (box.closest('s-sticky-form')) continue;              // never the sticky bar
      var cta = box.querySelector(CTA_SEL);
      if (!cta) continue;
      var h2 = handleFor(null, box);
      if (!h2) continue;
      if (EXCLUDED_HANDLES.indexOf(h2) !== -1) continue;
      box.setAttribute(BB_DONE_ATTR, '1');
      cta.insertAdjacentElement('afterend', buildBanner(stockNumberForHandle(h2)));
    }
  }

  /* ----- Init ------------------------------------------------------------- */
  injectStyles();

  function run() { injectStyles(); placeBanners(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run for late / AJAX-rendered buy boxes (sticky form, region swaps, etc.).
  // Debounced; self-disconnects after 10s since buy boxes are server-rendered.
  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; placeBanners(); }, 150);
  });
  function startObserver() {
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
  setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 10000);
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventOXYGW");}// Focal's hamburger opens the drawer on `pointerup` (capture) and stops
// propagation, so a plain click never reliably fires. Listen on pointerup in
// the CAPTURE phase at document level — that runs BEFORE the theme's own
// handler, so we always catch it.
document.addEventListener("pointerup", function (event) {
  // Control only — legacy header is hidden for variant B.
  if (document.documentElement.classList.contains("ig-nav-b")) return;

  var btn = event.target.closest && event.target.closest('[aria-controls="mobile-menu-drawer"]');
  if (!btn) return;

  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": "javascripteventOXYGW"
  });
}, true);

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventOOQEA");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '074094ef-3562-4012-a95f-9b1905e11951'; // Control Group
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (window.matchMedia('(max-width: 768px)').matches) return;  // desktop (NOT mobile)
    if (gid() !== GROUP) return;                                  // control
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventOOQEA' });
  });
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventCTBJD");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '9944d2ab-9bf7-4986-b3cd-220b43d9b789'; // New Group 1
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (!window.matchMedia('(max-width: 768px)').matches) return; // mobile
    if (gid() !== GROUP) return;                                  // variant
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventCTBJD' });
  });
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventBJYPM");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '9944d2ab-9bf7-4986-b3cd-220b43d9b789'; // New Group 1
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (window.matchMedia('(max-width: 768px)').matches) return;  // desktop (NOT mobile)
    if (gid() !== GROUP) return;                                  // variant
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventBJYPM' });
  });
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventIDLSR");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '074094ef-3562-4012-a95f-9b1905e11951'; // Control Group
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (!window.matchMedia('(max-width: 768px)').matches) return; // mobile
    if (gid() !== GROUP) return;                                  // control
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventIDLSR' });
  });
})();

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventHEAXK");}document.addEventListener("mouseover", function (event) {
  // Control only — the old nav is hidden for variant B, so this guard makes
  // sure the event is never attributed to a variant-B visitor.
  if (document.documentElement.classList.contains("ig-nav-b")) return;

  // Top-level old-nav items (Anti-Age System / Hair & Scalp Care /
  // Stop Dry Itchy Skin / More) plus the standalone SHOP ALL button.
  // The "> " child combinator excludes the mega-menu sub-links inside "More",
  // keeping this comparable with the variant-B top-level hover tracker.
  var item =
    event.target.closest &&
    event.target.closest(".header__linklist-item > .header__linklist-link, .button-shop-all");
  if (!item) return;

  // mouseover re-fires over child elements; count one hover per entry.
  if (window.__refirmNavHoverControl === item) return;
  window.__refirmNavHoverControl = item;

  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": "javascripteventHEAXK"
  });
});

// Reset when the cursor truly leaves the item, so a later re-hover counts.
document.addEventListener("mouseout", function (event) {
  if (window.__refirmNavHoverControl && !window.__refirmNavHoverControl.contains(event.relatedTarget)) {
    window.__refirmNavHoverControl = null;
  }
});

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventLARZL");}document.addEventListener("mouseover", function (event) {
  // Variant B only — the new nav is hidden for control, so this guard makes
  // sure the event is never attributed to a control visitor.
  if (!document.documentElement.classList.contains("ig-nav-b")) return;

  // Only the top-level menu items: Shop / Bestsellers / More.
  var item = event.target.closest && event.target.closest(".refirm-nav__nav-link[data-mega-target]");
  if (!item) return;

  // mouseover re-fires over child elements; count one hover per entry.
  if (window.__refirmNavHover === item) return;
  window.__refirmNavHover = item;

  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": "javascripteventLARZL" // keep YOUR generated identifier
  });
});

// Reset when the cursor truly leaves the item, so a later re-hover counts.
document.addEventListener("mouseout", function (event) {
  if (window.__refirmNavHover && !window.__refirmNavHover.contains(event.relatedTarget)) {
    window.__refirmNavHover = null;
  }
});

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

        window.cvg||(cvg=function(){cvg.process?cvg.process.apply(cvg,arguments):cvg.queue.push(arguments)},cvg.queue=[]);
        cvg({method:"track",eventName:"$page_load"});
      
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

        window.ALBSS = {
            event_key: '«your-event-key»'
        };
        
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

    document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-sections--26717504897391__announcement-bar').clientHeight + 'px');
  
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

    (function() {
      const countdownElements = document.querySelectorAll('#shopify-section-sections--26717504897391__announcement-bar .announcement-bar__countdown');
      
      countdownElements.forEach(function(countdownElement) {
        const dueDateString = countdownElement.getAttribute('data-due-date');
        if (!dueDateString) return;
        const timezone = countdownElement.getAttribute('data-timezone');

        function getDeadlineMs() {
          if (!timezone) return new Date(dueDateString).getTime();
          /* Convert "YYYY-MM-DDTHH:MM:SS" in the chosen timezone to a UTC timestamp.
             We find the UTC offset for that timezone at roughly the target time,
             then apply it to get the true UTC instant. */
          var parts = dueDateString.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
          if (!parts) return new Date(dueDateString).getTime();
          /* Create a rough UTC guess (treating input as UTC) */
          var guessUtc = Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6]);
          /* Format that UTC instant in the target timezone to find the offset */
          var fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
          });
          var tzStr = fmt.format(new Date(guessUtc));
          /* Parse "MM/DD/YYYY, HH:MM:SS" back to a Date to find the offset */
          var m = tzStr.match(/(\d{2})\/(\d{2})\/(\d{4}),?\s*(\d{2}):(\d{2}):(\d{2})/);
          var tzLocal = Date.UTC(+m[3], +m[1] - 1, +m[2], +m[4] === '24' ? 0 : +m[4], +m[5], +m[6]);
          var offsetMs = tzLocal - guessUtc;
          return guessUtc - offsetMs;
        }

        var deadlineMs = getDeadlineMs();

        function updateCountdown() {
          const now = Date.now();
          const distance = deadlineMs - now;

          if (distance < 0) {
            countdownElement.style.display = 'none';
            return;
          }

          const hours = Math.floor(distance / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const hoursEl = countdownElement.querySelector('[data-hours]');
          const minutesEl = countdownElement.querySelector('[data-minutes]');
          const secondsEl = countdownElement.querySelector('[data-seconds]');

          if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
          if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
        }

        updateCountdown();
        setInterval(updateCountdown, 1000);
      });
    })();
  
}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.isVisible = false;
      this._abortController = new AbortController();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-sticky-atc-submit]');
      this.priceDisplay = this.querySelector('[data-sticky-atc-price]');
      this.compareDisplay = this.querySelector('[data-sticky-atc-compare]');
      if (!this.button) return;

      const signal = this._abortController.signal;

      this.button.addEventListener('click', () => this.handleClick(), { signal });

      requestAnimationFrame(() => {
        this.setupVisibilityObserver();
        this.syncFromMainForm();
      });
    }

    disconnectedCallback() {
      this._abortController.abort();
      this._intersectionObserver?.disconnect();
      this._footerObserver?.disconnect();
      this._priceObserver?.disconnect();
    }

    findMainAddToCartButton() {
      return document.querySelector('.c-subscribtion__add-to-cart')
        || document.querySelector('.js-subscribtion__add-to-cart')
        || document.querySelector('.product-form button[type="submit"]:not(.sticky-atc__button)');
    }

    setupVisibilityObserver() {
      const mainBtn = this.findMainAddToCartButton();
      if (!mainBtn) return;

      this._mainBtnVisible = false;
      this._footerVisible = false;

      const apply = () => {
        const shouldShow = !this._mainBtnVisible && !this._footerVisible;
        if (shouldShow) {
          this.classList.add('sticky-atc--visible');
          this.isVisible = true;
        } else {
          this.classList.remove('sticky-atc--visible');
          this.isVisible = false;
        }
      };

      // Synchronous initial check on the main ATC.
      const rect = mainBtn.getBoundingClientRect();
      this._mainBtnVisible = rect.width > 0 && rect.height > 0
        && rect.bottom > 0 && rect.top < window.innerHeight;

      this._intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this._mainBtnVisible = entry.isIntersecting;
          requestAnimationFrame(apply);
        });
      }, { threshold: 0 });
      this._intersectionObserver.observe(mainBtn);

      // Hide the sticky bar when the footer scrolls into view.
      // The footer renders after this section in document order — Safari
      // fires connectedCallback before it's parsed, so we defer + poll.
      const trySetupFooter = (attempts = 0) => {
        if (this._footerObserver) return;
        const footer = document.querySelector('footer.footer, footer[role="contentinfo"]');
        if (footer) {
          this._footerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this._footerVisible = entry.isIntersecting;
              requestAnimationFrame(apply);
            });
          }, { threshold: 0 });
          this._footerObserver.observe(footer);
          return;
        }
        if (attempts < 50) setTimeout(() => trySetupFooter(attempts + 1), 100);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => trySetupFooter(), { once: true });
      } else {
        trySetupFooter();
      }

      apply();
    }

    /**
     * Sync availability + initial price from the rendered product form.
     * Refirm's <c-subscription> dispatches `product:price-updated` on variant/plan change,
     * but on first paint we read from DOM in case Liquid rendered a sold-out fallback
     * (e.g. on landing pages where `product` is nil).
     */
    syncFromMainForm() {
      const mainBtn = this.findMainAddToCartButton();
      if (!mainBtn) return;

      const isAvailable = !mainBtn.disabled && mainBtn.getAttribute('aria-disabled') !== 'true';
      if (isAvailable) {
        this.button.disabled = false;
        this.button.removeAttribute('disabled');
        const labelEl = this.button.querySelector('.sticky-atc__button-label');
        if (labelEl) {
          const txt = labelEl.textContent.trim().toLowerCase();
          if (txt === 'sold out' || txt === 'unavailable' || txt === '') {
            labelEl.textContent = this.dataset.buttonText || 'ADD TO CART';
          }
        }
        this.ensurePriceElements();
      }

      // Mirror the main button's price text. The main ATC has
      // `.js-subscribtion__main-price` and `.js-subscribtion__compare-at-price-wrapper`
      // which `updateAddToCartButton()` rewrites on every variant/plan change.
      this.syncPriceFromMain(mainBtn);
      this._priceObserver?.disconnect();
      this._priceObserver = new MutationObserver(() => this.syncPriceFromMain(mainBtn));
      this._priceObserver.observe(mainBtn, { childList: true, subtree: true, characterData: true });
    }

    syncPriceFromMain(mainBtn) {
      // Skip during transitional states (e.g. customAddToCartHelper's
      // "Adding..." swap). The main button temporarily replaces its
      // innerHTML, dropping the price wrappers — without this guard the
      // observer would briefly hide our compare-at and then restore it,
      // visible as a flicker on click.
      const mainPriceWrapper = mainBtn.querySelector('.js-subscribtion__main-price');
      if (!mainPriceWrapper) return;

      this.ensurePriceElements();

      const mainPriceEl = mainPriceWrapper.querySelector('.product_price') || mainPriceWrapper;
      let mainText = '';
      if (mainPriceEl && this.priceDisplay) {
        mainText = mainPriceEl.textContent.trim();
        if (mainText) this.priceDisplay.textContent = mainText;
      }

      // Compare-at: show whenever the main button has a compare price that
      // differs from the main price. Ignore the main button's `is-hidden`
      // visibility — we want the strikethrough on the sticky regardless.
      const compareInner = mainBtn.querySelector('.js-subscribtion__compare-at-price-wrapper .product_price')
        || mainBtn.querySelector('.js-subscribtion__compare-at-price .product_price');
      const compareText = compareInner ? compareInner.textContent.trim() : '';

      if (this.compareDisplay) {
        if (compareText && compareText !== mainText) {
          this.compareDisplay.textContent = compareText;
          this.compareDisplay.classList.remove('hidden');
        } else {
          this.compareDisplay.classList.add('hidden');
        }
      }
    }

    ensurePriceElements() {
      if (this.priceDisplay) return;
      const labelEl = this.button.querySelector('.sticky-atc__button-label');
      if (!labelEl) return;
      const priceSpan = document.createElement('span');
      priceSpan.className = 'sticky-atc__button-price';
      priceSpan.setAttribute('data-sticky-atc-price', '');
      labelEl.after(priceSpan);
      this.priceDisplay = priceSpan;

      const compareSpan = document.createElement('span');
      compareSpan.className = 'sticky-atc__button-compare hidden';
      compareSpan.setAttribute('data-sticky-atc-compare', '');
      priceSpan.after(compareSpan);
      this.compareDisplay = compareSpan;
    }

    /**
     * Delegate to the page's main ATC button — it's already wired with
     * onclick="customAddToCartHelper(this)" (see snippets/component-product-form-new.liquid).
     */
    handleClick() {
      const mainBtn = this.findMainAddToCartButton();
      if (!mainBtn) {
        console.warn('[Sticky ATC] No main add-to-cart button found.');
        return;
      }
      if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
      mainBtn.click();
    }
  }
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{

  document.addEventListener('DOMContentLoaded', () => {
    const handleReadMore = (event) => {
      const reviewCard = event.target.closest('.js-image-text-section__text');
      reviewCard.querySelector('[data-text="truncated"]').classList.add('is-hidden');
      reviewCard.querySelector('[data-text="full"]').classList.remove('is-hidden');
    };

    const handleReadLess = (event) => {
      const reviewCard = event.target.closest('.js-image-text-section__text');
      reviewCard.querySelector('[data-text="full"]').classList.add('is-hidden');
      reviewCard.querySelector('[data-text="truncated"]').classList.remove('is-hidden');
    };

    document.querySelectorAll('.js-image-text-section__read-more').forEach(btn => {
      btn?.addEventListener('click', handleReadMore);
    });

    document.querySelectorAll('.js-image-text-section__read-less').forEach(btn => {
      btn?.addEventListener('click', handleReadLess);
    });
  });

}catch(e){if(window.console)console.warn(e);}})();
;
(function(){try{
(function(){function leaf(e){return e.children.length===0;}function fx(){document.querySelectorAll('c-subscription label').forEach(function(l){if(/subscribe/i.test(l.textContent)){l.querySelectorAll('.product_price,[class*=price]').forEach(function(p){if(leaf(p)&&p.textContent.trim()==='$99')p.textContent='$79';});}});var sel=document.querySelector('c-subscription input:checked');var isOne=false;if(sel){var lb=sel.closest('label');if(lb&&/one.?time/i.test(lb.textContent))isOne=true;}document.querySelectorAll('[class*=add-to-cart] .product_price,[class*=cta] .product_price,.sticky-atc .product_price').forEach(function(p){if(leaf(p)&&!isOne&&p.textContent.trim()==='$99')p.textContent='$79';});document.querySelectorAll('.c-subscribtion__add-to-cart,.js-subscribtion__add-to-cart,[class*=add-to-cart],.main-cta-button__link').forEach(function(b){b.style.setProperty('background-color','#7c2350','important');b.style.setProperty('background-image','none','important');b.style.setProperty('color','#fff','important');});}function bt(){fx();var c=document.querySelector('c-subscription');if(c){new MutationObserver(fx).observe(c,{childList:true,subtree:true,characterData:true});c.addEventListener('change',fx,true);c.addEventListener('click',function(){setTimeout(fx,60);},true);}[120,400,900,1800,3000].forEach(function(t){setTimeout(fx,t);});setInterval(fx,600);}if(document.readyState!=='loading')bt();else document.addEventListener('DOMContentLoaded',bt);})();
}catch(e){if(window.console)console.warn(e);}})();